import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  ListingPanel,
  ListingPadder,
  OverallinModal,
  Area,
  Attributes,
  ListingContents,
  AgentInfoforDesktop,
  YoutubeVideo,
  Subject,
  HeaderLine,
  StickyContact,
  FancyText,
  MapHolder,
  ListingPhotoHolder,
  ListingandContact,
  SmallFancy,
  SmallFancyBold,
  ContactBorder,
  TopGrid,
  ShareHolder,
  LatestHaveInput,
  BoldedSpan,
  NavButton,
  LinkHeaderLine,
  MultifamilyBanner,
  AskAQuestionContainer,
  AgentInfoforMobile,
  EditPanel,
  EditButtons,
  MobileRoundCTAs,
  MobileRoundCTAIcon,
  RoundCTAsHolder,
  ContactsGrid,
  AboutTheAgentHolder,
  AboutAgentHeader,
  AboutAgentHeaderLine,
  AboutAgentLeftBio,
  AboutAgentRightBio,
  AboutAgentTitle,
  AboutAgentBioText,
  AboutAgentOverallFlex,
  AboutAgentBrokerageHolder,
} from "../../styles/ListingStyles";
import { FaStreetView } from "react-icons/fa";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime); // Required for fromNow() method
import { useRouter } from "next/router";
import {
  storage,
  firebaseAnalytics,
  getToken,
  auth,
} from "../../src/config/firebase";
import Link from "next/link";
import { useAuth } from "../../utils/auth/newAuth";
import { Formik, Field, useFormikContext, Form } from "formik";
import * as Yup from "yup";
import NumberFormat from "react-number-format";
import { AuthModal } from "../Auth/withAuthModal";
import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Avatar,
  useToast,
  Tooltip,
  Grid,
  Icon,
  Box,
  Button,
  Badge,
  Flex,
  Text,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Tag,
  TagLeftIcon,
  TagLabel,
  Textarea,
  List,
  ListIcon,
  ListItem,
  Stack,
  Select,
  useDisclosure,
  Divider,
  VStack,
  HStack,
  Switch,
  FormErrorMessage,
  ModalHeader,
  FormLabel,
  FormControl,
  AccordionIcon,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from "@chakra-ui/react";
import styles from "../../styles/listingStyles.module.css";
import "../../styles/react-carousel.es.module.css";
import Message from "../UI/Message/Message";
import slugify from "slugify";
import NextImage from "next/legacy/image";
import RelevantListing from "../ListingCard/RelevantListing";
import {
  RelevantImg,
  PseudoListingBox,
  Bolder,
} from "../ListingCard/ListingCardStyles";
import SubTypePhotos from "../../utils/SubTypePhotos/SubTypePhotos";
import useWindowSize from "../Utility/windowSize";
import ReactModal from "react-modal";
import {
  generatePass,
  clientAnalytics,
  urlify,
  PhoneNumberFormat,
  clientError,
} from "../../utils/utilties";
import {
  useLoadScript,
  StreetViewPanoramaProps,
  MarkerProps,
  CircleProps,
  // Marker,
  // Circle,
  GoogleMapProps,
} from "@react-google-maps/api";
// import Select from 'react-select';
import mapStyles from "../Search/mapStyles";
import marker from "../../public/images/marker.svg";
// import DownloadNDA from '../../components/NDA/downloadNDA'
import * as Sentry from "@sentry/nextjs";

import { useMutation, useQuery } from "react-query";
import {
  ImageHolder,
  ImageNavigationHolder,
  ImageScroller,
  InnerImage1,
  InnerImage2,
  InnerImage3,
  NavButtonDiv2,
  NavButtonHolder,
  NavButtonLeft,
  NavButtonRight,
  NavigationDotsHolder,
  NavigationInnerDiv,
  OuterShell,
  ScrollPreventer,
} from "../ListingCard/ListingCard2point0Styles";
import {
  MdBookmark,
  MdBookmarkBorder,
  MdChevronLeft,
  MdChevronRight,
  MdDashboard,
  MdEmail,
  MdNotificationAdd,
  MdNotificationsActive,
  MdShare,
  MdVerified,
  MdVisibility,
} from "react-icons/md";
import { provinceShorter } from "../ListingCard/ListingCard2point0";
import { RiMapPin2Fill } from "react-icons/ri";

import {
  FacebookShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  FacebookIcon,
  LinkedinIcon,
  WhatsappIcon,
  FacebookMessengerIcon,
  FacebookMessengerShareButton,
  TelegramShareButton,
  TelegramIcon,
} from "react-share";
import { BsBookmark, BsFillBarChartFill, BsFillBookmarkFill, BsFillTelephoneInboundFill, BsListStars } from "react-icons/bs";
import {
  DetailsFields,
  funnelTypes,
  industryRoleOptions,
  largeBusinessFields,
  ListingStatusOptions,
  MoneyFields,
  PercentFields,
  titleOptions,
} from "./data";
import { AiFillFileImage } from "react-icons/ai";
import { MyFormLabel, removeContactInformation } from "../../utils/clientUtilities";

import {
  PhoneIcon,
  EditIcon,
  ArrowForwardIcon,
  LockIcon,
  CheckCircleIcon,
  TimeIcon,
  ExternalLinkIcon,
  EmailIcon,
  CheckIcon,
  BellIcon,
} from "@chakra-ui/icons";
import ImageDrawer from "../ImageDrawer/ImageDrawer";
import SlideshowModal from "../SlideshowModal/SlideshowModal";
import QuestionsLeadForm from "../QuestionsLeadForm/QuestionsLeadForm";
import { isPossiblePhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import dynamic from "next/dynamic";
import {
  createUserWithEmailAndPassword,
  deleteUser,
  updateProfile,
} from "firebase/auth";
import { logEvent } from "firebase/analytics";
import { getDownloadURL, listAll, ref } from "firebase/storage";
import { MobileNavigation, NavIcon, NavItem, NavName } from "../Landing/MobileNavigation/StyledMobileNavigation";
import { IoIosShareAlt } from "react-icons/io";
import { OptionButton, OptionButtonList, OptionsHeader } from "../../styles/PathStyles";
import { greenTheme } from "../../styles/inputThemes";
import { Accordion, AccordionItem, AccordionButton, AccordionPanel } from "@chakra-ui/react";
import { AgentOuterShell, CardAnchor, LocationRow, NameInfo, NameRow, RowInfo } from "../FindAnAgent/AgentCardStyles";

const GoogleMap = dynamic<GoogleMapProps>(() =>
  import("@react-google-maps/api").then((module) => module.GoogleMap)
);
const StreetViewPanorama = dynamic<StreetViewPanoramaProps>(() =>
  import("@react-google-maps/api").then((module) => module.StreetViewPanorama)
);
const Marker = dynamic<MarkerProps>(() =>
  import("@react-google-maps/api").then((module) => module.Marker)
);
const Circle = dynamic<CircleProps>(() =>
  import("@react-google-maps/api").then((module) => module.Circle)
);



const CircleIcon = (props) => (
  <Icon viewBox='0 0 200 200' {...props}>
    <path
      fill='currentColor'
      d='M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0'
    />
  </Icon>
)

const libraries = ["places"];

// These are outside so react doesn't keep rerendering if these change
export const mapContainerStyle = {
  height: "100%",
  width: "100%",
};
export const options = {
  zoomControl: true,
  // styles: mapStyles
};

String.prototype["toProperCase"] = function () {
  return this.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

ReactModal.setAppElement("#__next");

const PhoneNumberInput = dynamic(
  () => import("../PhoneNumberInput/PhoneNumberInput")
);

const Listing = (props) => {
  const toast = useToast();
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.NEXT_PUBLIC_MAPS_API_KEY,
    // @ts-ignore
    libraries,
  });

  const mapRef = useRef(undefined);
  const onMapLoad = useCallback((map) => {
    mapRef.current = map;
  }, []);

  const size = useWindowSize();
  let scroller = React.useRef(null);
  let panelScroller = React.useRef(null);
  const [showQuizFunnel, setShowQuizFunnel] = useState(false);
  const [quizType, setQuizType] = useState("question");

  const [questionsLeadFormOpen, setQuestionsLeadFormOpen] = useState(false);
  const [similarListingAlertExists, setSimilarListingAlertExists] = useState(false);

  const {
    fListing,
    relevantListings,
    otherFromPoster,
    sortedAllListings,
    sortedBusinessListingsInCity,
    avgResponseTimeInDays,
    primary,
  } = props;

  const {
    subject,
    aiTagline,
    price,
    priority,
    priceType,
    propertyTypes,
    businessType,
    subTypes,
    lotSize,
    lotSizeUnit,
    subType,
    fileDescriptions,
    permittedUses,
    offMarket,
    distressed,
    unpriced,
    status,
    type,
    leaseType,
    postal,
    city,
    primaryImg,
    modifiedTimeStamp,
    marketing,
    province,
    showPhone,
    showAddress,
    coordinates,
    website,
    User,
    timeStamp,
    presentations,
    Unit,
    imageOrder,
    ceilingHeight,
    totalBuildingSize,
    websiteDescription,
    currentImprovements,
    streetViewEnabled,
    brokerCoop,
    commission,
    imageURLs,
    imagesFresh,
    _count: {
      Saved
    }
  } = fListing;

  const lastUpdated = modifiedTimeStamp || timeStamp;
  const {
    phone,
    fullName,
    industryRole,
    uid,
    slug,
    photoURL,
    brokeragePhoto,
    pro,
    plan,
    brokerage,
    about,
    title,
  } = User;
  const [imageArray, setImageArray] = useState(
    imagesFresh && imageURLs?.length > 0 ? imageURLs : null
  );


  const [translateValue, setTranslateValue] = useState(0);
  const [activeImg, setActiveImg] = useState(0);
  const heroImg = activeImg === 0 && primary ? primary : imageArray?.[activeImg];

  const router = useRouter();
  const [showPhoneNumber, setShowPhoneNumber] = useState(false);
  const { user, userId, profile } = useAuth();
  const [messageStatus, setMessageStatus] = useState("idle");
  const [errorMessage, setErrorMessage] = useState("");
  const [imageLoadStatus, setImageLoadStatus] = useState("idle");
  const [messageToSend, setMessageToSend] = useState(false);
  const [isAuthBoxOpen, setIsAuthBoxOpen] = useState(false);
  const [messageText, setMessageText] = useState("");
  const [signUpMethod, setSignUpMethod] = useState("");
  const [authModalEmail, setAuthModalEmail] = useState("");
  const [authModalEmailType, setAuthModalEmailType] = useState<
    "new" | "existing" | null
  >(null);
  const [authModalPhoneType, setAuthModalPhoneType] = useState<
    "new" | "existing" | null
  >(null);
  const [userValidationError, setUserValidationError] = useState<
    "emailInvalid" | "phoneInvalid"
  >(null);
  const leadFormValidationSchema = Yup.object().shape({
    firstName: Yup.string()
      .required("Please enter your first name")
      .min(2, "First name must be at least 2 characters")
      .max(50, "First name must be less than 50 characters"),

    lastName: Yup.string()
      .required("Please enter your last name")
      .min(2, "Last name must be at least 2 characters")
      .max(50, "Last name must be less than 50 characters"),

    industryRole: Yup.string().required("Industry role missing"),
    email: Yup.string().required("Email is required"),
    brokerage: Yup.string().min(
      5,
      "Brokerage name must be longer than 5 characters"
    ),
    title: Yup.string(),
    // message: Yup.string().max(1000, "Too long.").min(1, "Too short.")
  });
  const [leadFormValues, setLeadFormValues] = useState({
    message: "",
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    industryRole: "",
    brokerage: "",
    title: "",
  });
  const [translatePixels, SetTranslatePixels] = useState(0);
  const [flyerFiles, setFlyerFiles] = useState(null);
  const [authHeader, setAuthHeader] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState(null);
  const [photoBoxImg, setPhotoBoxImg] = useState();
  const [visitTracked, setVisitTracked] = useState(false);
  // const [streetView, setStreetView] = useState(false);
  const [saveStatus, setSaveStatus] = useState("idle");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [callBackPending, setCallBackPending] = useState(false);
  const [updateModalMode, setUpdateModalMode] = useState(null);
  const [callBackRequested, setCallBackRequested] = useState(false)
  const {
    isOpen: messageBoxOpen,
    onOpen: onMessageBoxOpen,
    onClose: onMessageBoxClose,
  } = useDisclosure();
  const {
    isOpen: isListingStatusModalOpen,
    onOpen: onListingStatusModalOpen,
    onClose: onListingStatusModalClose
  } = useDisclosure()
  const [phoneData, setPhoneData] = useState("");
  const [userType, setUserType] = useState<"existing" | "new">(undefined);

  const [formValues, setFormValues] = useState({});
  const [thisListingConversationId, setThisListingConversationId] =
    useState(undefined);
  const [thisListingSavedSearchId, setThisListingSavedSearchId] =
    useState(undefined);
  const [thisListingSavedId, setThisListingSavedId] = useState(null);
  const [showingStreetView, setShowingStreetView] = useState(false);
  const [similarListingAlertPending, setSimilarListingAlertPending] =
    useState(false);
  const [listingStatusFormValue, setListingStatusFormValue] = useState({
    initial: '',
    current: ''
  })

  const [priorityToSet, setPriorityToSet] = useState({
    initial: priority,
    current: priority
  })
  const [deleteBlockStatus, setDeleteBlockStatus] = useState<'idle' | 'loading' | 'done'>('idle');
  const { isOpen: isDeleteBlockOpen, onOpen: onDeleteBlockOpen, onClose: onDeleteBlockClose } = useDisclosure();
  const deleteBlockCancelRef = useRef(null);
  async function handleDeleteAndBlock() {
    onDeleteBlockClose();
    setDeleteBlockStatus('loading');
    try {
      const token = await getToken();
      const res = await fetch('/api/admin/delete-and-block', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', token },
        body: JSON.stringify({ targetUid: fListing.uid }),
      });
      const data = await res.json();
      if (res.ok) {
        toast({ title: `Done — deleted ${data.deletedListings} listing(s) and blocked the user.`, status: 'success', duration: 6000, isClosable: true });
        setDeleteBlockStatus('done');
      } else {
        toast({ title: 'Error', description: data.error, status: 'error', duration: 6000, isClosable: true });
        setDeleteBlockStatus('idle');
      }
    } catch (err) {
      toast({ title: 'Unexpected error', status: 'error', duration: 6000, isClosable: true });
      setDeleteBlockStatus('idle');
    }
  }
  async function updateImagesRequest(receivedData) {
    const response = await fetch(`/api/listings/${id}/update?imagesOnly=true`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updatedData: receivedData }),
    });

    const data = await response.json();
    const { listing } = data;
    return listing;
  }
  // Manage loading state for createcampaign
  const [creatingCampaign, setCreatingCampaign] = useState(false);
  const [campaignId, setCampaignId] = useState(null);
  const [campaignText, setCampaignText] = useState(null);
  async function createCampaignRequest() {
    setCreatingCampaign(true);
    const response = await fetch(`/api/createCampaign`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ listingId: id }),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data?.error || "Campaign creation failed");
    }
    return data;
  }

  const createCampaign = useMutation(createCampaignRequest, {
    onError: (error) => {
      // An error happened!
      clientError(error);
      // Create an error toast
      toast({
        title: "Campaign error",
        description: error instanceof Error ? error.message : "Unexpected error",
        status: "error",
        duration: 5000,
        isClosable: true,
      })

    },
    onSuccess: (data) => {
      if (data?.campaignId) {
        setCampaignId(data.campaignId);
        window.open(`https://mc.sendgrid.com/single-sends/${data.campaignId}/editor`, '_blank');
      } else {
        throw Error
      }
    },
    onSettled: () => {
      setCreatingCampaign(false);
    }
  });

  const [similarListingAlertStatus, setSimilarListingAlertStatus] =
    useState("idle");


  const updateImages = useMutation(updateImagesRequest, {
    onError: (error) => {
      // An error happened!
      clientError(error);
    },
  });

  async function updateListingRequest(receivedData) {
    const response = await fetch(`/api/listings/${id}/update`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: await getToken(),
        userId: userId,
      },
      body: JSON.stringify({ updatedData: receivedData }),
    });

    const data = await response.json();
    const { listing } = data;
    return listing;
  }

  const commonQuestions = [
    "Can you send me more info?",
    "Can I book a showing?",
    unpriced ? "What’s your price expectation?" : "Is the price negotiable?",
    !showAddress ? "What's the property's address?" : "Can you tell me more about the location?"

  ]


  const updateListing = useMutation(updateListingRequest, {
    onError: (error, variables, context) => {
      clientError(error);
      toast({
        title: "Error",
        description: `An error occured. Please try again later.`,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    },

    onSuccess: (data, variables, context) => {
      if (data) {
        revalidateListing.mutate();

        toast({
          title: "Listing Updated.",
          variant: "subtle",
          description: `The listing was successfully updated`,
          status: "success",
          duration: 5000,
          isClosable: true,
        });



      } else {
        throw "error";
      }
      // If the listing wansn't private or approved, remove images
      // delete any associated images
    },
    onSettled: () => {
      onListingStatusModalClose();
    }
  });

  async function revalidateListingRequest() {
    const response = await fetch(`/api/revalidate`, {
      method: "POST",
      headers: {
        secret: process.env.NEXT_PUBLIC_REVALIDATION_TOKEN
      },
      body: JSON.stringify({ path: `/listings/${id}/${slugify(subject)}` }),
    });

    const data = await response.json();
    const { revalidated } = data;
    return revalidated;
  }
  const revalidateListing = useMutation(revalidateListingRequest, {
    onError: (error, variables, context) => {
      clientError(error);
    },
    onSuccess(data, variables, context) {
      router.reload();
    },
  })

  const updateSavedSearchReq = async (passedData) => {
    // setUpdateStatus("loading");
    // setDeleteProcessLoading(true);
    const response = await fetch(`/api/savedSearch/${thisListingSavedSearchId}/update`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: await getToken(),
      },
      body: JSON.stringify({ updatedData: passedData }),
    });

    const data = await response.json();
    const { savedSearches } = data;

    return savedSearches;
  };

  const savedSearchUpdate = useMutation(updateSavedSearchReq, {
    onError: (error) => {
      // setUpdateStatus("idle");
      toast({
        title: "Error",
        variant: "subtle",
        description: `An error occured. Please try again later.`,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      clientError(error);
    },

    onSuccess: (theData) => {
      if (theData) {
        if (!theData["live"]) {
          setSimilarListingAlertExists(false);
          setThisListingSavedSearchId(null);
          toast({
            title: "Updated",
            description: "Removed listing alert successfully.",
            variant: "subtle",
            status: "success",
            duration: 2000,
            isClosable: true,
          });
        }
      } else throw "error";
    },
  });

  const removeSaveReq = async () => {
    // setUpdateStatus("loading");
    // setDeleteProcessLoading(true);
    const response = await fetch(`/api/saves/${thisListingSavedId}/remove`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: await getToken(),
      },
    });

    const data = await response.json();
    const { removed } = data;

    return removed;
  };

  const removeListingSave = useMutation(removeSaveReq, {
    onError: (error) => {
      // setUpdateStatus("idle");
      toast({
        title: "Error",
        variant: "subtle",
        description: `An error occured. Please try again later.`,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      clientError(error);
    },

    onSuccess: (theData) => {
      if (theData) {
        setThisListingSavedId(null);
        setSaveStatus('idle');
        toast({
          variant: "subtle",
          status: "success",
          title: "Saved search removed"
        })
      } else throw "error";
    },
  });
  const onShareBoxClose = () => {
    setIsModalOpen(false);
    setUserType(undefined);
  };

  useEffect(() => {
    if (fListing) {
      setMessageText(`Hi ${firstName}, is this still available?`);
      setCampaignId(null);
      setCampaignText(null)
      // Undo saved
      setSaveStatus("idle");
      setCallBackRequested(false);
      setThisListingSavedSearchId(null);

      // Track visit
      const profileProps = profile ? {
        email: profile?.email,
        firstName: profile?.firstName,
        lastName: profile?.lastName,
        phone: profile?.phone,
      } : {};

      clientAnalytics.track("Listing page viewed (client)", {
        id,
        subject,
        status,
        propertyTypes,
        country: "Canada",
        subTypes,
        type,
        "Listing City": city,
        province,
        ...profileProps
      });

      thisListingConversationId ? setThisListingConversationId(null) : null;
      messageStatus == 'success' ? setMessageStatus('idle') : null;
      saveStatus == 'success' ? setSaveStatus('idle') : null;


      // @ts-ignore
      logEvent(firebaseAnalytics, "view_item", {
        value: price,
        items: [
          {
            id: id.toString(),
            google_business_vertical: "real_estate",
          },
        ],
      });
    }
  }, [fListing]);

  // useEffect(() => {
  //   if (profile && messageToSend) {
  //     messageMutation.mutate({
  //       uid: userId,
  //       message: messageText,
  //       listingId: Number(id),
  //     });
  //     setMessageToSend(false);
  //   }
  // }, [profile]);

  // useEffect(() => {
  //   if (profile && similarListingAlertPending) {
  //     similarListingAlertMutation.mutate();
  //     setUserType(undefined);
  //   }
  // }, [profile]);

  useEffect(() => {
    if (profile) {
      // If signed out user wanted to save search, do it as soon as they sign in
      if (similarListingAlertPending) {
        similarListingAlertMutation.mutate();
        setUserType(undefined);
      }

      // If signed out user wanted to send a message, do it as soon as they sign in
      if (messageToSend) {
        messageMutation.mutate({
          uid: userId,
          message: messageText,
          listingId: Number(id),
        });
        setMessageToSend(false);
      }

      if (callBackPending) {
        callBackHandler();
        setCallBackPending(false);
      }
    }
  }, [profile]);

  const modalPhotoChange = (type) => {
    if (type === "back") {
      // Find the index of the current image
      // change the img to the one that is one less than this index
      // if the index is 0 then make it the length - 1
      let imgCopy = [...imageArray["downloadURLs"]];
      const index = imgCopy.indexOf(photoBoxImg);
      if (index === 0) {
        setPhotoBoxImg(imgCopy[imgCopy.length - 1]);
      } else {
        setPhotoBoxImg(imgCopy[index - 1]);
      }
    }

    if (type === "forward") {
      // Find the index of the current image
      // change the img to the one that is one less than this index
      // if the index is 0 then make it the length - 1
      let imgCopy = [...imageArray["downloadURLs"]];
      const index = imgCopy.indexOf(photoBoxImg);
      if (index === imgCopy.length - 1) {
        setPhotoBoxImg(imgCopy[0]);
      } else {
        setPhotoBoxImg(imgCopy[index + 1]);
      }
    }
  };

  async function createUserRequest(userData) {
    let IPAddress;
    try {
      const IPresponse = await fetch("https://jsonip.com", { mode: "cors" });
      const IPobj = await IPresponse.json();
      IPAddress = IPobj ? IPobj["ip"] : null;
    } catch (e) {
      clientError(e);
    }

    const response = await fetch("/api/users/create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: await getToken(),
        ip: IPAddress ? IPAddress : null,
      },
      body: JSON.stringify({ user: userData }),
    });

    const data = await response.json();
    const { user } = data;

    return user;
  }

  const createUserRequestMutation = useMutation(createUserRequest, {
    onError: (error) => {
      toast({
        title: "Error",
        description: `An error occured. Please try again later.`,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      clientError(error);
      // setSignupStatus("error");
      setErrorMessage(error["message"]);
    },

    onSuccess: async (data) => {
      if (data) {
        const { uid } = data;
        messageMutation.mutate({
          uid,
          message: messageText,
          listingId: Number(id),
        });
        // profileRefetch()
      }

      // User record didn't go through
      else {
        // Throw error
        // Delete user record from firebase
        props.onClose ? props.onClose() : null;
        await deleteUser(auth.currentUser);

        throw "Error creating user after Google auth";

        // Set method back to blank
        // setMethod("");
      }
    },
  });

  const signUpUser = async (userData: typeof leadFormValues) => {
    const {
      email,
      firstName,
      lastName,
      industryRole,
      phone,
      title,
      brokerage,
    } = userData;
    try {
      let pass = generatePass();
      const response = await createUserWithEmailAndPassword(auth, email, pass);
      // If user is on the sign up page when signing up
      if (response.user) {
        // lockCheck();
        const { uid } = response.user;

        clientAnalytics.track("User created", {
          type: "Email",
          uid: uid,
        });

        clientAnalytics.identify(uid, {
          name: firstName + " " + lastName,
          email: email,
          phone: phoneData,
        });

        // Don't send password up to the server
        const userData = {
          email,
          firstName,
          lastName,
          fullName: firstName + " " + lastName,
          phone,
          title,
          brokerage,
          industryRole,
          uid,
        };

        await updateProfile(auth.currentUser, {
          displayName: firstName + " " + lastName,
        });

        createUserRequestMutation.mutate(userData);
      } else {
        toast({
          title: "Error",
          description: `An error occured. Please try again later.`,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        clientError(
          "Firebase did not come back with user in quiz funnel"
        );
      }
    } catch (error) {
      clientError(error);
      toast({
        title: "Error 2",
        description: error?.message
          ? error.message
          : "An error occured, please try again later",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };



  const toggleStreetView = () => {
    setShowingStreetView(!showingStreetView);
  };

  async function saveVisitRequest(visitData) {

    let IPAddress;
    try {
      const IPresponse = await fetch("https://jsonip.com", { mode: "cors" });
      const IPobj = await IPresponse.json();
      IPAddress = IPobj ? IPobj["ip"] : null;
    } catch (e) {
      clientError(e);
    }
    visitData["IPAddress"] = IPAddress;

    const response = await fetch("/api/visits/create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data: visitData }),
    });
    const data = await response.json();
    const { returnObj } = data;
    return returnObj;
  }

  const visitMutation = useMutation(saveVisitRequest, {
    onSuccess(data, variables, context) {
      if (data?.thisConvoId) {
        setMessageStatus("success")
        setThisListingConversationId(data.thisConvoId);
      }

      if (data?.alreadySaved) {
        setSaveStatus("success")
        setThisListingSavedId(data.alreadySaved);
      }

      if (data?.savedSearchId) {
        setSimilarListingAlertExists(true)
        setThisListingSavedSearchId(data.savedSearchId)
      }

    },
    onError: (error) => {
      clientError(error);
    },
  });

  const MyCheckerComponent = () => {
    const { isValid, values, errors } = useFormikContext();

    useEffect(() => {
      // setFormValid(isValid);

      setFormValues(values);
    }, [isValid, values]);

    return null;
  };

  const saveHandler = async () => {
    // Set phone number to true

    // Add event record
    saveMutation.mutate({
      listingId: id,
      uid: userId,
    });

    // Track on mixpanel
    clientAnalytics.track("Listing saved");
  };

  const PropertyTypeButtonCreator = () => {
    let theLinks = [];
    propertyTypes.map((i, index) => {
      theLinks.push(
        <Link key={index} prefetch={false} href={`/listings/${slugify(i)}`}>

          <Button
            mr="2px"
            fontWeight={"400"}
            verticalAlign={"inherit"}
            paddingY="0px"
            marginY="0px"
            textDecoration={"underline"}
            display="inline"
            variant="link"
            colorScheme="myGray"
          >
            {i}
          </Button>

        </Link>
      );
    });

    return theLinks;
  };

  const quizFunnelCancelled = () => {
    const quizFunnel: any = localStorage.getItem("quizFunnelData");
    // if (quizFunnel) {
    //   quizFunnel = JSON.parse(quizFunnel)
    // }
    const date = new Date();
    const quizFunnelDate = new Date(quizFunnel?.expires).getTime();
    if (quizFunnelDate < date.getTime()) {
      date.setDate(date.getDate() + 7);

      const quizFunnelData = {
        expires: date,
      };
      localStorage.setItem("quizFunnelData", JSON.stringify(quizFunnelData));
    }
    setShowQuizFunnel(false);

    clientAnalytics.track("Quiz funnel cancelled", {
      listing: id,
      subject,
      propertyTypes,
      subTypes,
      type,
      city,
      province,
      industryRole,
      fullName,
    });
  };

  const quizFunnelStarter = () => {
    // Don't show if a user exists
    if (user) return;

    let quizFunnel: any = localStorage.getItem("quizFunnelData");
    if (quizFunnel) {
      quizFunnel = JSON.parse(quizFunnel);
    }

    const quizFunnelDate = new Date(quizFunnel?.expires).getTime();
    const quizFunnelExpired = quizFunnelDate < new Date().getTime();

    if (quizFunnelExpired || !quizFunnel) {
      const date = new Date();
      date.setDate(date.getDate() + 7);
      setShowQuizFunnel(true);
      const quizFunnelData = {
        expires: date,
      };
      localStorage.setItem("quizFunnelData", JSON.stringify(quizFunnelData));

      clientAnalytics.track("Quiz funnel modal displayed", {
        listing: id,
        subject,
        propertyTypes,
        subTypes,
        type,
        city,
        province,
        industryRole,
        fullName,
      });
    }
  };

  // Exit Intent
  // Disabled exit intent
  // useEffect(() => {
  //     if (!user) {
  //         setTimeout(() => {
  //             quizFunnelStarter();
  //         }, 10000);
  //     }

  // }, [user])


  async function saveListingRequest(saveData) {
    setSaveStatus("loading");
    const response = await fetch("/api/saves/create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data: saveData }),
    });

    const data = await response.json();
    const { save } = data;

    return save;
  }

  const saveMutation = useMutation(saveListingRequest, {
    onError: (error) => {
      clientError(error);
      toast({
        position: "bottom",
        title: "Error saving listing",
        description:
          "We couldn't save this listing at this time - we're looking into the cause of this. Please try again in a bit",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    },

    onSuccess: (data) => {
      if (!data) {
        setSaveStatus("idle");

        throw "Error tracking visit";
      } else {
        setThisListingSavedId(data.id);
        setSaveStatus("success");
        toast({
          position: "bottom",
          title: "Listing saved",
          description:
            "It is now visible in your saved listings on the left panel",
          status: "success",
          variant: "subtle",
          duration: 5000,
          isClosable: true,
        });
      }
    },
  });

  let firstName = User ? User.fullName.split(" ")[0] : "";

  const onAuthBoxClose = () => {
    setAuthModalEmail("");
    setAuthModalEmailType(null);
    setSignUpMethod("");
    setIsAuthBoxOpen(false);
    setUserType(undefined);
  };

  const phoneNumberHandler = async () => {
    // Set phone number to true
    if (!showPhoneNumber) {
      setShowPhoneNumber(true);

      // Add event record
      visitMutation.mutate({
        listingId: id,
        uid: userId,
        type: "Viewed phone number",
      });
    }
  };

  const id = props.id;

  useEffect(() => {
    if (id && !visitTracked) {
      if (!profile) {
        visitMutation.mutate({
          listingId: id,
          type: "View",
        });
      } else if (profile && userId != User["uid"]) {
        visitMutation.mutate({
          listingId: id,
          uid: userId,
          type: "View",
        });

        setVisitTracked(true);


      }
    }
  }, [id, profile]);
  const ObjtoStr = (obj) => {
    if (typeof obj === "string") {
      return obj;
    } else {
      let theArr = obj.map((piece) => {
        return piece.label;
      });

      return theArr.join(", ");
    }
  };

  // const listingRef = ref(storage, `listingImages/${id}/compressed`);
  let periodIndex = primaryImg?.lastIndexOf(".");
  let primaryImageName = primaryImg?.substring(0, periodIndex);
  let primaryImageExt = primaryImg?.substring(periodIndex);

  // let primaryImageExt = primaryImg?.split(".")[-1];
  // let primaryImageName = primaryImg?.split(primaryImageExt)[0];
  // Get the userInfo and Images
  const imageGetter = async () => {
    if (imageURLs?.length == 0 || !imagesFresh) {
      let returnedFiles = await listAll(
        ref(storage, `listingImages/${id}/compressed`)
      );
      let returnedItems = returnedFiles.items;

      // let localPrimary

      if (returnedItems.length > 0) {
        if (imageOrder?.length > 0) {
          // Go through every item in the image order and add it to the array

          let promiseArray = [];
          imageOrder.forEach(async (f) => {
            returnedItems
              .filter((it) => it.name.includes("1200x1200"))
              .forEach((it) => {
                const fileName = it.name.split(/\.(?=[^\.]+$)/)[0];
                fileName.replace("_1200x1200", "");
                if (
                  fileName === f?.split(/\.(?=[^\.]+$)/)[0] + "_1200x1200" ||
                  fileName === f?.split(/\.(?=[^\.]+$)/)[0]
                ) {
                  promiseArray.push(getDownloadURL(it));
                }
              });
          });

          Promise.all(promiseArray).then((downloadURLs) => {
            setImageArray(downloadURLs);
            updateImages.mutate(
              {
                imageURLs: downloadURLs,
                id: id,
              },
              id
            );
          });
        } else {
          // Multiple photos
          let imagePromises = returnedItems.reduce(
            (accumulator, currentValue) => {
              if (currentValue.name.includes("_1200x1200")) {
                //loading up only x700 files

                if (
                  currentValue.name !==
                  `${primaryImageName}_1200x1200${primaryImageExt}`
                ) {
                  // if image isn't the primary image
                  accumulator.push(getDownloadURL(currentValue)); // move it to the initial point of the array
                } else {
                  accumulator.unshift(getDownloadURL(currentValue));
                }
              }
              return accumulator;
            },
            []
          );

          Promise.all(imagePromises).then((downloadURLs) => {
            setImageArray([...downloadURLs]);

            updateImages.mutate({
              imageURLs: downloadURLs,
              id: id,
            });
          });
        }
      } else {
        setImageArray(null);
        return;
      }
    } else {
      if (imageURLs?.length > 0) {
        setActiveImg(0);
        setImageArray(imageURLs);
      } else {
        setImageArray(null);
      }
    }
  };

  useEffect(() => {
    imageGetter();
  }, [fListing]);

  const fileArrayCreator = async () => {
    // const listingFilesRef = ref(storage, `listingFiles/${id}`)
    let returnedFiles = await listAll(ref(storage, `listingFiles/${id}`));

    let returnedItems = returnedFiles.items;
    // let uncompressedItems = uncompressedFiles.items

    // No pre-existing files
    if (returnedItems.length === 0) {
      return;
    } else {
      let promises = returnedItems.reduce(function (result, fl) {
        result.push(getDownloadURL(fl));
        return result;
      }, []);

      Promise.all(promises).then((downloadURLs) => {
        let stateReady = [];
        downloadURLs.forEach((i, index) => {
          let theName = returnedItems[index]["name"];
          let description =
            fileDescriptions && fileDescriptions[theName]
              ? fileDescriptions[theName]
              : "Listing file";
          stateReady.push({
            link: i,
            description,
          });
        });
        setFlyerFiles(stateReady);
      });
    }
  };



  // async function fetchStreetVRwquest() {
  //   const response = await fetch(
  //     `https://maps.googleapis.com/maps/api/streetview/metadata?key=${process.env.NEXT_PUBLIC_MAPS_API_KEY}&location=${coordinates["lat"]},${coordinates["lng"]}`,
  //     {
  //       method: "GET",
  //       // headers: {
  //       //     "Content-Type": "application/json",
  //       // },
  //     }
  //   );
  //   const data = await response.json();
  //   return data;
  // }

  // const { data, error: responseError } = useQuery(
  //   "streetview",
  //   fetchStreetVRwquest,
  //   {
  //     enabled: !!fListing && !!coordinates && showAddress && streetViewEnabled,
  //     refetchOnWindowFocus: false,
  //     onSuccess: (data) => {
  //       if (data) {
  //         const { status } = data;
  //         if (status == "OK" && id != 522) {
  //           setStreetView(true);
  //         }
  //       } else {
  //         throw "Couldn't get a response from Google about street view";
  //       }
  //     },

  //     onError: (error) => {
  //       clientError(error);
  //     },
  //   }
  // );

  useEffect(() => {
    if (fListing) {
      // const listingRef = storage.ref(`listingFiles/${id}`)

      // listingRef.child(fListing.flyerFile).getDownloadURL().then(url => {
      //     setFlyerURL(url)
      // }).catch(err => {
      //     console.error(err);
      // })
      fileArrayCreator();
    }
  }, [fListing]);


  async function createMessageRequest(messageData) {
    messageStatus == "loading" ? null : setMessageStatus("loading");
    const response = await fetch("/api/messages/create?scenario=L1", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: await getToken(),
      },
      body: JSON.stringify({ message: messageData }),
    });

    const data = await response.json();
    return data;
  }

  const messageMutation = useMutation(createMessageRequest, {
    onError: (error) => {
      // An error happened!
      clientError(error);
      setMessageStatus("error");
      toast({
        position: "bottom",
        title: "Message failed",
        description: `Your message failed to send to ${firstName}. We're looking into this now and will get back to you as soon as we can.`,
        status: "error",
        duration: 5000,
      });
    },

    onSuccess: async (data, variables, context) => {
      if (data.theMessage) {
        const { theMessage } = data;
        const { convoId, senderEmail, senderPhone } = theMessage;
        setMessageStatus("success");
        setThisListingConversationId(convoId);
        setMessageToSend(false);
        onShareBoxClose();
        setModalMode(null);

        clientAnalytics.track("DM to listing owner (client)", {
          senderEmail,
          senderPhone,
          city,
          listing: id.toString(),
          fullName,
          propertyTypes,
          province,
          subTypes,
          subject,
          type,
        });

        try {
          // @ts-ignore
          window.lintrk("track", { conversion_id: 9003106 });

        }
        catch (e) {
          console.error('Could not track LinkedIn conversion')
        }
      }

      else if (data.specificError) {
        setMessageStatus('idle');
        setMessageToSend(false);
        onShareBoxClose();
        setModalMode(null);
        toast({
          title: data.specificError,
          status: "warning",
          variant: "subtle",
          duration: 5000,
          isClosable: true,
        });
      }
      else if (data.requiresUniqueMessage) {
        setMessageStatus('idle');
        // Deliberately don't close the compose box or reset messageToSend -
        // the user needs to edit and resend. Skip the trailing
        // onMessageBoxClose() below, which would otherwise undo this.
        onMessageBoxOpen();
        toast({
          title: "Looks like you've sent this exact message before",
          description: "Please personalize your message before sending it again.",
          status: "info",
          variant: "subtle",
          duration: 6000,
          isClosable: true,
        });
        return;
      }
      else {
        throw "An error occured trying to send DM";
      }
      messageBoxOpen && onMessageBoxClose();
    },
  });

  async function createSimilarListingAlertRequest() {
    similarListingAlertStatus == "loading"
      ? null
      : setSimilarListingAlertStatus("loading");
    const response = await fetch(
      "/api/savedSearch/similarListingAlertCreation",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: await getToken(),
        },
        body: JSON.stringify({ fListing }),
      }
    );

    const data = await response.json();
    const { createdListingAlert } = data;
    return createdListingAlert;
  }

  const similarListingAlertMutation = useMutation(
    createSimilarListingAlertRequest,
    {
      onError: (error) => {
        // An error happened!
        Sentry.captureException(error);
        setMessageStatus("error");
        toast({
          position: "bottom",
          title: "Alert creation failed",
          description: `Your alert wasn't saved at this time. We're looking into this now and will get back to you as soon as we can.`,
          status: "error",
          duration: 5000,
        });
      },

      onSuccess: async (data, variables, context) => {
        if (data) {

          setSimilarListingAlertStatus("success");
          setThisListingSavedSearchId(data.id);
          createSimilarListingAlertRequest
          setSimilarListingAlertExists(true);
          toast({
            position: "bottom",
            title: data.alreadyExists ? "Alert already exists" : "You'll be alerted about listings like this one",
            description: data.alreadyExists ? `An alert like this already exists in your account. You'll be the first to know when listings like this one are posted.` : "You'll be the first to know when listings like this one are posted.",
            status: "success",
            variant: "subtle",
            duration: 5000,
          });

        } else {
          throw "An error occured trying to save this alert";
        }
      },

      onSettled: () => {
        setSimilarListingAlertStatus("idle");
        setSimilarListingAlertPending(false);
      },
    }
  );

  const copyContent = () => {
    navigator.clipboard.writeText(listingUrl);

    clientAnalytics.track("Listing Shared", {
      Medium: "Copy and Paste",
      "Listing Id": id,
      Prompt: "Listing page",
      Subject: subject,
    });

    shareListing("Copy and Paste");
    toast({
      position: "bottom",
      title: "Link copied!",
      status: "success",
      variant: "subtle",
      duration: 2000,
      isClosable: true,
    });
  };

  const listingUrl = fListing
    ? `https://zonado.com/listings/${encodeURIComponent(id)}/${slugify(
      subject.toProperCase()
    )}`
    : "";

  interface TriggerAuthProps {
    hook: string;
    header: string;
    signUpMethod?: "email" | "verify";
    userEmail?: string;
    authModalEmailType?: "existing";
  }
  const triggerAuth = ({
    hook,
    header,
    signUpMethod,
    userEmail,
    authModalEmailType,
  }: TriggerAuthProps) => {
    // Mixpanel.track(hook, { "Listing": id });

    clientAnalytics.track("Sign up attempted", {
      hook,
      listing: id.toString(),
      subject: subject,
      type,
      propertyTypes,
      subTypes,
      city,
      province,
    });

    userEmail && setAuthModalEmail(userEmail);
    authModalEmailType && setAuthModalEmailType(authModalEmailType);
    signUpMethod && setSignUpMethod(signUpMethod);
    setAuthHeader(header);
    setIsAuthBoxOpen(true);
  };

  const RelevantListings = (
    <>
      {relevantListings?.length > 0 ? (
        <>
          {propertyTypes?.length > 0 ? (
            <Flex
              alignItems="flex-end"
              justifyContent="space-between"
              mb="3px"
              mt="30px"
            >
              <Link
                prefetch={false}
                href={
                  province?.length > 0
                    ? `/listings/${provinceShorter(province)}/${slugify(
                      propertyTypes[0]
                    )}`
                    : `/listings/${slugify(propertyTypes[0])}`
                }>
                <LinkHeaderLine>
                  More {propertyTypes[0]} listings{" "}
                  {!!city ? `around ${city}` : `nearby`}
                </LinkHeaderLine>
              </Link>

              <Link
                prefetch={false}
                href={
                  province?.length > 0
                    ? `/listings/${provinceShorter(province)}/${slugify(
                      propertyTypes[0]
                    )}`
                    : `/listings/${slugify(propertyTypes[0])}`
                }>

                <Button
                  colorScheme="green"
                  variant="solid"
                  size="sm"
                  mb="3px"
                  borderRadius="20px"
                >
                  View all
                </Button>

              </Link>
            </Flex>
          ) : (
            <Flex alignItems="flex-end" justifyContent="space-between" mb="3px">
              <HeaderLine>More listings around {city}</HeaderLine>
              <Link prefetch={false} href={`/listings`}>

                <Button
                  colorScheme="green"
                  variant="solid"
                  size="sm"
                  mb="3px"
                  borderRadius="20px"
                >
                  View all
                </Button>

              </Link>
            </Flex>
          )}
          {/* <div className={styles.sectionDivider} /> */}

          <Box
            marginTop="20px"
            overflow="hidden"
            position="relative"
            transition="all 0.5s ease"
          >
            <Flex
              ref={scroller}
              transform={`translateX(${translatePixels + "px"})`}
              overflowX="auto"
            >
              {relevantListings?.map((listing) => (
                <Link
                  prefetch={false}
                  key={listing.id}
                  href={`?listingId=${listing.id}`}
                  as={`/listings/${encodeURIComponent(listing.id)}/${slugify(
                    listing.subject.toProperCase()
                  )}`}
                >

                  <RelevantListing {...listing} />

                </Link>
              ))}

              {/* Only show right button if the number of listings exceeds the width */}

              <PseudoListingBox>
                <RelevantImg>
                  <NextImage
                    layout="fill"
                    objectFit="cover"
                    src={`/images/listing/listingTypes/${SubTypePhotos(
                      propertyTypes[0]
                    )}.jpg`}
                  />
                </RelevantImg>
                <Box p="12px 14px 14px">
                  <Text
                    color="#1a202c"
                    as="h3"
                    fontSize="13.5px"
                    fontWeight="600"
                    lineHeight="1.4"
                    marginBottom="12px"
                  >
                    See more <Bolder>{propertyTypes[0]}</Bolder> listings
                  </Text>

                  <Link prefetch={false} href={`/listings/${slugify(propertyTypes[0])}`}>
                    <Button
                      width="100%"
                      size="sm"
                      borderColor={"brand.900"}
                      color={"brand.900"}
                      _hover={{ borderColor: "brand.800" }}
                      variant="outline"
                    >
                      See More
                    </Button>
                  </Link>
                </Box>
              </PseudoListingBox>
            </Flex>
          </Box>
        </>
      ) : null}
    </>
  );
  const AllSimilarListings = (
    <>
      {propertyTypes?.length > 0 ? (
        <>
          <Flex alignItems="flex-end" justifyContent="space-between" mt="30px">
            <Link prefetch={false} href={`/listings/${slugify(propertyTypes[0])}`}>
              <LinkHeaderLine>All {propertyTypes[0]} listings </LinkHeaderLine>
            </Link>

            <Link href={`/listings/${slugify(propertyTypes[0])}`}>

              <Button
                colorScheme="green"
                variant="solid"
                size="sm"
                mb="3px"
                borderRadius="20px"
              >
                View all
              </Button>

            </Link>
          </Flex>
        </>
      ) : (
        <Flex alignItems="flex-end" justifyContent="space-between" mt="30px">
          <HeaderLine>Similar listings on Zonado</HeaderLine>

          <Link href={`/listings`}>

            <Button
              colorScheme="green"
              variant="solid"
              size="sm"
              mb="3px"
              borderRadius="20px"
            >
              View all
            </Button>

          </Link>
        </Flex>
      )}

      {/* <div className={styles.sectionDivider} /> */}

      <Box
        marginTop="12px"
        overflow="hidden"
        position="relative"
        transition="all 0.5s ease"
      >
        <Flex
          ref={scroller}
          transform={`translateX(${translatePixels + "px"})`}
          overflowX="auto"
        >
          {sortedAllListings?.map((listing) => (
            <Link
              key={listing.id}
              href={`?listingId=${listing.id}`}
              as={`/listings/${encodeURIComponent(listing.id)}/${slugify(
                listing.subject.toProperCase()
              )}`}>

              <RelevantListing {...listing} />

            </Link>
          ))}

          {/* Only show right button if the number of listings exceeds the width */}
          {propertyTypes?.length > 0 && (
            <PseudoListingBox>
              <RelevantImg>
                <NextImage
                  layout="fill"
                  objectFit="cover"
                  alt={`${propertyTypes[0]} listings`}
                  src={`/images/listing/listingTypes/${SubTypePhotos(
                    propertyTypes[0]
                  )}.jpg`}
                />
              </RelevantImg>
              <Box p="12px 14px 14px">
                <Text
                  color="#1a202c"
                  as="h3"
                  fontSize="13.5px"
                  fontWeight="600"
                  lineHeight="1.4"
                  marginBottom="12px"
                >
                  See more <Bolder>{propertyTypes[0]}</Bolder> listings
                </Text>

                <Link href={`/listings/${slugify(propertyTypes[0])}`}>
                  <Button
                    width="100%"
                    size="sm"
                    borderColor={"brand.900"}
                    color={"brand.900"}
                    _hover={{ borderColor: "brand.800" }}
                    variant="outline"
                  >
                    See More
                  </Button>
                </Link>
              </Box>
            </PseudoListingBox>
          )}
        </Flex>
      </Box>
    </>
  );

  const SimilarBusinessListings = (
    <>
      {sortedBusinessListingsInCity?.length > 0 ? (
        <>
          <Flex alignItems="flex-end" justifyContent="space-between" mt="30px">
            <Link prefetch={false} href={`/listings/${slugify(propertyTypes[0])}`}>
              <LinkHeaderLine>
                More {businessType} listings around {city}
              </LinkHeaderLine>
            </Link>
            <Link
              href={`/listings${province ? `/${provinceShorter(province)}` : ''}${city ? `/${city}` : ''}/${slugify(
                businessType
              )}`}>

              <Button
                colorScheme="green"
                variant="solid"
                size="sm"
                mb="3px"
                borderRadius="20px"
              >
                View all
              </Button>

            </Link>
          </Flex>

          <Box
            marginTop="12px"
            overflow="hidden"
            position="relative"
            transition="all 0.5s ease"
          >
            <Flex
              ref={scroller}
              transform={`translateX(${translatePixels + "px"})`}
              overflowX="auto"
            >
              {sortedBusinessListingsInCity?.map((listing) => (
                <Link
                  key={listing.id}
                  href={`?listingId=${listing.id}`}
                  as={`/listings/${encodeURIComponent(listing.id)}/${slugify(
                    listing.subject.toProperCase()
                  )}`}
                >

                  <RelevantListing {...listing} />

                </Link>
              ))}

              {/* Only show right button if the number of listings exceeds the width */}
              {/* {propertyTypes?.length > 0 && (
                  <PseudoListingBox>
                    <RelevantImg>
                      <NextImage
                        src={`/images/listing/listingTypes/${SubTypePhotos(
                          propertyTypes[0]
                        )}.jpg`}
                        width={220}
                        height={131}
                        layout="responsive"
                      />
                      <Box p="15px">
                        <Text
                          color="#4a4a4a"
                          as="h3"
                          fontWeight="400"
                          marginBottom="20px"
                        >
                          See more <Bolder>{propertyTypes[0]}</Bolder> listings
                        </Text>

                        <Link
                          href={`/listings/${slugify(propertyTypes[0])}`}
                          passHref
                        >
                          <a>
                            <Button
                              width="100%"
                              size="sm"
                              borderColor={"brand.900"}
                              color={"brand.900"}
                              _hover={{ borderColor: "brand.800" }}
                              variant="outline"
                            >
                              See More
                            </Button>
                          </a>
                        </Link>
                      </Box>
                    </RelevantImg>
                  </PseudoListingBox>
                  )} */}
            </Flex>
          </Box>
        </>
      ) : (
        <></>
      )}
    </>
  );

  if (fListing && status === "pending") {
    return (
      <Box
        h="90vh"
        paddingTop="20px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <h1>This listing is under review and will be once approved.</h1>
      </Box>
    );
  }

  // Not needed anymore, since user will be redirected from getStaticProps
  // if (fListing && fListing.status === "deleted") {
  //   return (
  //     <OverallinModal>
  //       <Box
  //         width="100%"
  //         padding="15px 23px 15px"
  //         maxHeight="auto"
  //         maxW="1180px"
  //         margin="0 auto"
  //       >
  //         <StateSvg
  //           svg={emptyState}
  //           heading={`You just missed it!`}
  //           subHeading={`Looks like this listing is no longer available. ${
  //             relevantListings?.length > 0 || sortedAllListings?.length > 0
  //               ? "Here are some more like it that you might like:"
  //               : "Click search listings below to view all listings"
  //           }`}
  //         />

  //         {RelevantListings}

  //         {sortedAllListings?.length > 0 && AllSimilarListings}
  //         {/* <AllSimilarListings /> */}
  //       </Box>

  //       <Box h="50px" />

  //       {/* <NewFooter faq={false} isProfessional={false} /> */}
  //     </OverallinModal>
  //   );
  // }

  const preventDefault = (f) => (e) => {
    e.preventDefault();
    f(e);
  };

  const PhoneJSX = () => {
    return (
      <Button
        colorScheme="green"
        color="green.500"
        size="sm"
        leftIcon={<PhoneIcon />}
        variant="outline"
        mr="5px"
        onClick={() => {
          userId
            ? phoneNumberHandler()
            : triggerAuth({
              hook: "View phone number",
              header: "Log in or sign up to view phone number",
            });
        }}
        flexGrow={1}
      >
        {showPhoneNumber ? (
          <a href={`tel:${phone}`}>
            <PhoneNumberFormat phone={phone} />{" "}
          </a>
        ) : (
          `View phone number`
        )}
      </Button>
    );
  };

  const shareListing = (medium) => {
    // Mixpanel.track("Listing Shared", { "Medium": medium, "Listing Id": id, "Prompt": "Listing page"  });

    // clientAnalytics.track("Listing Shared", { "Medium": medium, "Listing Id": id, "Prompt": "Listing page" })
    // Mixpanel.track("Listing Shared", { "Medium": medium, "Listing Id": id, "Prompt": "Listing page"  });
    // Add event record
    visitMutation.mutate({
      listingId: id,
      uid: userId,
      type: "Shared listing",
    });
  };

  const EmailSchema = Yup.object().shape({
    fullName: Yup.string()
      .required("Full name is required")
      .min(2, "Full name must be at least 2 characters")
      .max(25, "Full name is too long."),

    email: Yup.string().required("Email is required"),

    industryRole: Yup.string().required("Industry role missing"),

    brokerage: Yup.string().min(
      5,
      "Brokerage name must be longer than 5 characters"
    ),
  });

  function closeListingStatusModal() {
    onListingStatusModalClose()
  }

  function showListingStatusModal() {
    setUpdateModalMode("status")
    setListingStatusFormValue({
      initial: status,
      current: status
    })
    onListingStatusModalOpen()
  }

  function showListingPriorityModal() {
    setUpdateModalMode("priority")

    onListingStatusModalOpen()
  }

  const saveRequest = async () => {
    if (saveStatus == 'success') {
      // user wants to remove
      removeListingSave.mutate();
      return;
    }
    user
      ? await saveHandler()
      : triggerAuth({
        hook: "Save listing",
        header: "Log in or sign up to save listing",
      });
  }
  const shareRequest = () => {
    setIsModalOpen(true);
    setModalMode("share");
  }

  const callBackHandler = () => {
    setQuizType("callback");
    setQuestionsLeadFormOpen(true);
  }

  const confirmPhone = () => {
      setQuizType("confirmPhone");
      setQuestionsLeadFormOpen(true);
  }
  const brokeragePhotoComp = ((brokeragePhoto ||
    // one of the co listers have a valid brokerage photo
    fListing.coListers?.find(i => i.brokeragePhoto)) &&
    <Box
      width="131px"
      height={"auto"}
      position={"relative"}
      marginTop={{ base: "20px", md: "0px" }}
      marginBottom={{ base: "20px", md: "0px" }}
      marginX="auto"
    >
      <Image src={brokeragePhoto ? brokeragePhoto : fListing.coListers.find(i => i.brokeragePhoto).brokeragePhoto}
        objectFit="contain"
        maxWidth="100%" height="100%" />
    </Box>
  )
  const callBackRequest = () => {
    if (callBackRequested) {
      toast({
        status: "success",
        variant: "subtle",
        title: `Call back already requested`,
        description: `You've already requested a call back from ${firstName}`

      })
      return;
    }

    if (user) {
      callBackHandler();
      try {
        // @ts-ignore
        window?.analytics.track("Call back requested")
      }
      catch (e) {
        console.error(e)
      }
    }
    else {
      setCallBackPending(true);
      triggerAuth({
        hook: "Request call back",
        header: "Log in or sign up to request a call",
      });
    }


  }

  const listingAlertRequest = () => {
    if (userIsNotSignedIn) {

      setSimilarListingAlertPending(true);
      triggerAuth({
        hook: "Notify me for listings like these",
        header:
          "Create a free account to confirm your alert",
      });
    }

    // user is trying to remove
    else if (similarListingAlertExists) {
      savedSearchUpdate.mutate({ live: false });
    }

    // User is trying to create
    else similarListingAlertMutation.mutate()
  }

  const commonQuestionRequest = (i: string) => {

    if (user) {
      setMessageText(i);
      messageMutation.mutate({
        uid: userId,
        message: i,
        listingId: Number(id),
      })

      onMessageBoxOpen();
      try {

        // @ts-ignore
        window?.analytics.track('Common question sent', {
          question: i
        })
      }
      catch (e) {
        console.error(e);
      }
    }

    else {
      setMessageText(i);
      setMessageToSend(true);
      triggerAuth({
        hook: "Common question",
        header:
          "Create a free account to ask this question",
      });
    }
  }
  const SaveAndShare = (
    <Grid gridTemplateColumns="1fr 1fr" gridColumnGap="16px">
      <Button
        variant="link"
        leftIcon={
          saveStatus == "success" ? <BsFillBookmarkFill /> : <BsBookmark />
        }
        textDecoration="underline"
        isLoading={saveStatus == "loading"}
        loadingText="Saving"
        isDisabled={saveStatus == "success"}
        fontWeight="500"
        colorScheme="green"
        onClick={async () => {
          saveRequest();
        }}
      >
        {saveStatus == "success"
          ? "Saved"
          : saveStatus == "loading"
            ? "Saving"
            : "Save"}
      </Button>
      <Button
        variant="link"
        leftIcon={<MdShare />}
        textDecoration="underline"
        fontWeight="500"
        colorScheme="green"
        onClick={shareRequest}
      >
        Share
      </Button>
    </Grid>
  );
  const listingIsAvailable =
    status != "Expired" && status != "deleted" && status != "Sold";
  const userIsNotSignedIn = !userId;
  const isZonadoOrBrokerageAdmin = profile?.userRole == "admin" ||
    (profile?.userRole == "brokerageAdmin" &&
      brokerage &&
      profile?.brokerage === brokerage)
  const listingIsExpired = status == 'Expired' || status == 'Sold' || status == 'deleted';


  const isZonadoAdmin = profile?.userRole == "admin";
  const signedInUserOwnsListing = userId && (fListing.uid === userId || fListing.coListers.find(i => i.uid == userId));

  const roundCTAs = (listingIsAvailable &&
    <RoundCTAsHolder>
      <Flex w="100%" justify="space-between" alignItems="center">
        {/* <Box display="inline-flex" alignItems="center">
        <TimeIcon mr="4px" />
        Updated {dayjs(modifiedTimeStamp).format("MMM D, YYYY")}
      </Box> */}

        < MobileRoundCTAs>
          <Tooltip aria-label={"Get an alert for listings similar to this one"}
            label={"Get an alert for listings similar to this one"}
            // display={{base:"none", xs: "block"}}
            // placement="right-end"
            paddingY={"6px"}
            fontFamily={"Inter, sans-serif"}
            zIndex={10}
          >
            <NavItem
              onClick={listingAlertRequest}
            >
              {/* Alert */}

              <MobileRoundCTAIcon active={similarListingAlertExists}>
                {similarListingAlertExists ?
                  <MdNotificationsActive
                    color="#125f3f"
                    size="22px"
                  />

                  :
                  <MdNotificationAdd
                    color="#000"
                    size="22px"
                  />
                }
              </MobileRoundCTAIcon>
              <Button
                mt="5px"
                variant="link"
                size="sm"
                colorScheme={similarListingAlertExists ? "green" : "black"}
              >
                {similarListingAlertExists ? "Alert created" : "Create alert"}
              </Button>
            </NavItem>
          </Tooltip>

          {/* Save */}
          <NavItem
            onClick={saveRequest}
          >
            <MobileRoundCTAIcon active={saveStatus == "success"}>

              <MdBookmark
                color={saveStatus == "success" ? "#125F3F" : "#000"}
                size="22px"
              />
            </MobileRoundCTAIcon>
            <Button
              mt="5px"
              variant="link"
              size="sm"
              colorScheme={saveStatus == "success" ? "green" : "#000"}
            >
              {saveStatus == "success"
                ? "Saved"
                : saveStatus == "loading"
                  ? "Saving"
                  : "Save"}
            </Button>
          </NavItem>

          {/* Share */}
          <NavItem
            onClick={shareRequest}
          >
            <MobileRoundCTAIcon >
              <IoIosShareAlt
                color="#000"
                size="22px"
              />
            </MobileRoundCTAIcon>
            <Button
              mt="5px"
              variant="link"
              size="sm"
              colorScheme={"black"}
            >Share</Button>
          </NavItem>

          {/* Only show call back requested if this person isn't already chatting about this listing */}
          {!thisListingConversationId &&
            <Tooltip aria-label={"Request the owner of this listing to give you a call back."}
              label={"Request the owner of this listing to give you a call back."}
              // display={{base:"none", xs: "block"}}
              // placement="right-end"
              paddingY={"6px"}
              fontFamily={"Inter, sans-serif"}
              zIndex={10}
            >
              <NavItem
                onClick={callBackRequest}
              >
                <MobileRoundCTAIcon active={callBackRequested}>
                  <BsFillTelephoneInboundFill
                    color={callBackRequested ? "#125f3f" : "#000"}
                    size="22px"
                  />
                </MobileRoundCTAIcon>
                <Button
                  mt="5px"
                  variant="link"
                  size="sm"
                  colorScheme={callBackRequested ? "green" : "black"}

                >{callBackRequested ? "Call requested" : "Request call"}</Button>
              </NavItem>
            </Tooltip>
          }
        </MobileRoundCTAs>

        {/* {SaveAndShare} */}
      </Flex>
    </RoundCTAsHolder>
  )

  const ShortMessageFormik = (
    <Formik
      initialValues={{ ...leadFormValues, message: messageText }}
      validationSchema={leadFormValidationSchema}
      onSubmit={async (values, { setSubmitting }) => {
      }}
    >
      {({ isValid, handleChange, handleSubmit, values, touched, errors }) => (
        <>
          {/* When user signed in, show a simple message box */}
          {(
            listingIsAvailable &&
            !signedInUserOwnsListing &&
            messageStatus !== "success" && (
              <Form>
                <Flex
                  flexDir="column"
                  justifyContent="center"
                  width={"100%"}
                  mt="10px"
                >
                  <Box mb="10px">
                    <MyFormLabel htmlFor="message">
                      <HStack height={"18px"}>
                        <Box>Message {firstName}</Box>
                      </HStack>
                    </MyFormLabel>
                    <Field name="message">
                      {({ field, form }) => (
                        <Textarea
                          {...field}
                          {...form}
                          focusBorderColor="green"
                          id="message"
                          type="string"
                          height="20px"
                          minHeight={"60px"}
                          value={messageText}
                          onChange={(e) => {
                            setMessageText(e.target.value);
                          }}
                          // autoFocus={!router.pathname.includes("presentation")}
                          fontSize="16px"
                          _focus={greenTheme}
                          name="message"
                          tabIndex={1}
                          label="Message"
                          resize="vertical"
                        />
                      )}
                    </Field>
                  </Box>

                  {touched["message"] && messageText.length > 1000 ? (
                    <Box alignSelf={"flex-start"}>
                      <Text color="tomato" fontSize="12px">
                        Message too long
                      </Text>
                    </Box>
                  ) : (
                    touched["message"] &&
                    messageText.length < 2 && (
                      <Box alignSelf={"flex-start"}>
                        <Text color="tomato" fontSize="12px">
                          Message too short
                        </Text>
                      </Box>
                    )
                  )}

                  <Button
                    onClick={() => {
                      if (userId) {
                        if (profile.phone) {
                          messageMutation.mutate({
                            uid: userId,
                            message: messageText,
                            listingId: id,
                          });
                        }

                        else {
                          // confirmPhone()
                          setSignUpMethod("social");
                          setAuthModalEmailType('new')
                          setAuthModalPhoneType('new')
                          setMessageToSend(true)
                          // Confirm phone number to message
                          clientAnalytics.track("User clicked to message without phone number", {
                            userId: userId,
                            listingId: id
                          })
                          triggerAuth({
                            hook: `Confirm phone number to message`,
                            header: `Confirm your phone number to message ${firstName}`,
                          });
                        }


                      }

                      else {
                        // verifyUserData(values);
                        // setUserType("new");
                        setMessageToSend(true)
                        triggerAuth({
                          hook: `Sign in to send message`,
                          header: `Create a free account or sign in in to message ${firstName}`,
                        });

                      }
                    }}
                    type="submit" // does not trigger the onSubmit function from formik
                    isLoading={messageStatus === "loading"}
                    loadingText="Sending Message"
                    isDisabled={
                      messageText.length < 2 || messageText.length > 1000
                    }
                    tabIndex={2}
                    colorScheme="green"
                  >
                    {" "}
                    Send a message
                  </Button>
                </Flex>
              </Form>
            )
          )}


          {messageStatus === "success" && (
            <Box>
              <Alert mt="12px" status="success" variant="subtle">
                <AlertIcon />
                <Box>
                  <AlertTitle fontWeight="600">
                    {" "}
                    You've messaged {firstName.toProperCase()}.{" "}
                  </AlertTitle>
                  <AlertDescription>
                    <Link href={`/inbox?conv=${thisListingConversationId}`}>

                      <Button
                        rightIcon={<ArrowForwardIcon />}
                        fontWeight={"600"}
                        verticalAlign={"inherit"}
                        paddingY="0px"
                        marginY="0px"
                        variant="link"
                        colorScheme="green"
                      >
                        Go to the chat
                      </Button>

                    </Link>
                  </AlertDescription>
                </Box>
              </Alert>
            </Box>
          )}

          {messageStatus === "error" && (
            <Message error success={undefined} noShow={undefined}>
              {errorMessage}
            </Message>
          )}
        </>
      )}
    </Formik>
  );
  const ContactBorderBox =

    <ContactBorder size={size}>
      {slug ? (
        <Link href={`/profile/${slug}`}>

          <Flex alignItems="center">
            <Avatar mr="8px" size="md" src={photoURL || ""} />
            <Box>
              <SmallFancyBold>
                {fullName?.toProperCase()}{" "}
              </SmallFancyBold>
              <Flex mt="8px">
                {pro && (
                  <Badge
                    mr="6px"
                    variant="solid"
                    colorScheme="green"
                  >
                    Pro
                  </Badge>
                )}
                <Badge
                  variant="outline"
                  colorScheme={"gray"}
                  display="inline-block"
                >
                  {industryRole}
                </Badge>
              </Flex>
            </Box>
          </Flex>

        </Link>
      ) : (
        <Flex alignItems="center">
          <Avatar
            mr="8px"
            size="md"
            src={User ? User.photoURL : ""}
          />
          <Box>
            <SmallFancyBold>{fullName} </SmallFancyBold>
            <Flex mt="8px">
              {pro && (
                <Badge
                  mr="6px"
                  variant="solid"
                  colorScheme="green"
                >
                  Pro
                </Badge>
              )}
              <Badge
                variant="outline"
                colorScheme={"gray"}
                display="inline-block"
              >
                {industryRole}
              </Badge>
            </Flex>
          </Box>
        </Flex>
      )}

      {((!!avgResponseTimeInDays && avgResponseTimeInDays <= 2) ||
        priority > 1) && (
          <Flex gap="7px" alignItems={"center"} my="10px">
            <Image
              src="/images/listing/fast-responder-chat-icon.svg"
              width={"16px"}
              height={"16px"}
            />
            {avgResponseTimeInDays === 1 || priority > 1 ? (
              <Text fontSize={"14px"} display="inline-block">
                <Text as="span" color="#39AB65">
                  Very
                </Text>{" "}
                responsive to messages
              </Text>
            ) : (
              <Text fontSize={"14px"} display="inline-block">
                Responsive to messages
              </Text>
            )}
          </Flex>
        )}

      {ShortMessageFormik}
    </ContactBorder>




  const propTypeForFunnel = propertyTypes.filter((value) =>
    funnelTypes.includes(value?.toLowerCase())
  )[0];



  return (<>
    <OverallinModal images={imageLoadStatus !== "null"}>
      <ListingPanel ref={panelScroller}>
        <ListingPadder>
          {/* edit listing button */}
          {(signedInUserOwnsListing ||
            isZonadoOrBrokerageAdmin) && (
              <EditPanel>
                <EditButtons>
                  <Link href={`/add-listing?id=${id}`} target="_blank">

                    <Button
                      colorScheme="green"
                      leftIcon={<EditIcon />}
                      mt="16px"
                      variant="outline"
                    >
                      Edit Listing
                    </Button>

                  </Link>

                  <Button
                    colorScheme="green"
                    leftIcon={<MdVisibility />}
                    mt="16px"
                    onClick={() => showListingStatusModal()}
                    variant="outline"
                  >
                    Change status
                  </Button>
                  <Link href={`/dashboard?id=${id}`} target="_blank">

                    <Button
                      colorScheme="green"
                      leftIcon={<MdDashboard />}
                      mt="16px"
                      variant="outline"
                    >
                      View dashboard
                    </Button>

                  </Link>

                  {isZonadoAdmin &&
                    <Button
                      colorScheme="green"
                      leftIcon={<BsFillBarChartFill />}
                      mt="16px"
                      onClick={() => showListingPriorityModal()}
                      variant="outline"
                    >
                      Change priority
                    </Button>
                  }
                  {isZonadoAdmin &&
                    <Button
                      colorScheme="green"
                      leftIcon={<MdEmail />}
                      mt="16px"
                      isLoading={creatingCampaign}
                      onClick={() => {
                        // Make an api call to create a campaign and send this listing id in the request body

                        createCampaign.mutate();
                      }}
                      variant="outline"
                    >
                      Create campaign
                    </Button>
                  }
                  {isZonadoAdmin &&
                    <Button
                      colorScheme="red"
                      mt="16px"
                      isLoading={deleteBlockStatus === 'loading'}
                      isDisabled={deleteBlockStatus === 'done'}
                      onClick={onDeleteBlockOpen}
                    >
                      Delete &amp; Block
                    </Button>
                  }

                </EditButtons>
              </EditPanel>

            )}
          {isZonadoAdmin && campaignId &&
            <>
              <Alert status='success'>
                <Flex
                  flexDirection={"column"}
                  gridRowGap="16px"
                >
                  <div>

                    <AlertIcon />
                    <Link href={`https://mc.sendgrid.com/single-sends/${campaignId}/editor`} target="_blank" >
                      
                        Go to campaign
                      

                    </Link>
                  </div>
                  <p>{campaignText}</p>
                </Flex>
              </Alert>
            </>

          }
          {/* </DataLine> */}
          <ListingandContact>
            <ListingContents images={imageLoadStatus !== "none"}>
              {status === "private" && (
                <>
                  <Tag size="sm" colorScheme="green" mb="10px">
                    <TagLeftIcon as={LockIcon} boxSize="12px" />
                    <TagLabel paddingBottom="1px">Private Listing</TagLabel>
                  </Tag>

                  <Tooltip
                    // zIndex="20"
                    aria-label="Private listings can only be seen and shared by those who have the link. They do not appear in search results."
                    label="Private listings can only be seen and shared by those who have the link. They do not appear in search results."
                    placement="right-end"
                  >
                  
                    <Icon
                      name="question"
                      marginLeft="5px"
                      marginBottom="5px"
                    />
                  </Tooltip>
                </>
              )}
              <Flex
                flexDir={{ base: "column-reverse", md: "column" }}
              >
                <TopGrid>
                  {(status == "Expired" ||
                    status == "Sold" ||
                    status == "Conditionally Sold") && (
                      <Alert
                        status="info"
                        variant="top-accent"
                        borderRadius={"8px"}
                      >
                        <AlertIcon />
                        This listing has been marked as {status}
                      </Alert>
                    )}

                  {status == "Draft" && (
                    <Alert
                      status="info"
                      variant="top-accent"
                      borderRadius={"8px"}
                    >
                      <AlertIcon />
                      This listing is currently a draft and not publicly
                      visible.
                    </Alert>
                  )}

                  {!userId && listingIsExpired && (
                    <AskAQuestionContainer>
                      <VStack alignItems={"flex-start"}>
                        <Text
                          fontWeight={"600"}
                          fontSize="24px"
                          lineHeight={"18px"}
                        >
                          Missed it? Don't miss the next one.
                        </Text>
                        <Text fontSize="15px">
                          {`Hundreds of Canadian commercial and business listings are posted here each month - many not available anywhere else. Create a free alert to make sure you don’t miss the next ${subTypes[0]
                            ? subTypes[0] + " listing"
                            : businessType
                              ? businessType + " listing"
                              : " listing"
                            }${city ? ` in ${city}` : ""}.`}
                        </Text>
                      </VStack>
                      <Box>
                        <Button
                          bgColor="#0B76D9"
                          color="#fff"
                          width={{ base: "100%", sm: null }}
                          py="20px"
                          px="35px"
                          isDisabled={similarListingAlertStatus == "success"}
                          isLoading={similarListingAlertStatus == "loading"}
                          leftIcon={
                            similarListingAlertStatus ==
                              "success" ? (
                              <CheckIcon />
                            ) : (
                              <EmailIcon />
                            )
                          }
                          _hover={{
                            opacity: "0.8",
                          }}
                          onClick={() => {
                            setSimilarListingAlertPending(true);
                            triggerAuth({
                              hook: "Notify me for listings like these",
                              header:
                                "Create a free account to confirm your alert",
                            });
                          }}
                        >
                          {similarListingAlertStatus == "success"
                            ? "Alert created"
                            : "Alert me for the next one"}
                        </Button>
                        <Text textAlign={"center"} fontSize="13px">No spam. Ever.</Text>
                      </Box>
                    </AskAQuestionContainer>
                  )}

                  <Subject>{subject.toProperCase()}</Subject>

                  {aiTagline && status === "Available" && (
                    <Box mt="4px">
                      <Text
                        fontSize={{ base: "14px", md: "15px" }}
                        color="gray.600"
                      >
                        {aiTagline}
                      </Text>
                      <Text fontSize="11px" color="gray.400" mt="2px">
                        AI-generated summary
                      </Text>
                    </Box>
                  )}

                  {isZonadoAdmin && lastUpdated && (
                    <Text
                      fontSize={{ base: "13px", md: "14px" }}
                      color="gray.500"
                      mt="8px"
                      mb="4px"
                    >
                      Last updated {dayjs(lastUpdated).format("MMM D, YYYY")}
                    </Text>
                  )}

                  <Flex
                    gridColumnGap={"12px"}
                  >
                    {offMarket && (
                      <Box>
                        <Badge
                          // size="sm"
                          // variant="subtle"
                          // borderRadius="16px"
                          colorScheme="green"
                        >
                          Not on MLS®
                        </Badge>
                      </Box>
                    )}

                    {distressed &&
                      <div>
                        <Badge
                          color="#fff"
                          colorScheme='red'>distressed sale</Badge>
                      </div>
                    }
                  </Flex>

                  {unpriced || !price ? (
                    <SmallFancy> Unpriced</SmallFancy>
                  ) : (
                    !["Expired", "Sold"].includes(status) && (
                      <SmallFancy>
                        <NumberFormat
                          value={price}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                          suffix={
                            type == "For Lease" && priceType
                              ? `/${priceType} ${leaseType ? `(${leaseType})` : ""
                              }`
                              : ""
                          }
                        />
                      </SmallFancy>
                    )
                  )}

                  <SmallFancy>
                    {/* @ts-ignore */}
                    {!propertyTypes.includes("Sale of Business")
                      ? `${type}:`
                      : ""}{" "}
                    {PropertyTypeButtonCreator().map((e, i) => {
                      return [i > 0 && ", ", e];
                    })}{" "}
                    {city ? "in " : ""}{" "}
                    {city ? (
                      <Link
                        prefetch={false}
                        href={`/listings${province ? `/${provinceShorter(province)}` : ''}/${slugify(
                          city
                        )}`}>

                        <Button
                          fontWeight={"400"}
                          verticalAlign={"inherit"}
                          paddingY="0px"
                          marginY="0px"
                          textDecoration={"underline"}
                          display="inline"
                          variant="link"
                          colorScheme="myGray"
                        >{`${city}${province ? ", " + provinceShorter(province) : ""
                          }`}</Button>

                      </Link>
                    ) : (
                      ""
                    )}
                  </SmallFancy>


                </TopGrid>
                {imageArray && (
                  <ListingPhotoHolder>
                    <OuterShell>
                      <div style={{ position: "relative" }}>
                        <ImageScroller>
                          <ImageNavigationHolder>
                            <span>
                              <ImageHolder>
                                {/* <Link href={`/listings/${id}/${slugify(subject).toProperCase()}/gallery`} passHref>
                                                            <ImageAnchor aria-hidden="true" tabindex="-1" aria-label={subject} />
                                                        </Link> */}

                                <InnerImage1>
                                  <InnerImage2>
                                    <InnerImage3>
                                      {/* Blurred copy fills the letterbox bars left by objectFit="contain"; same src/sizes so the browser reuses the download */}
                                      <Box
                                        aria-hidden="true"
                                        position="absolute"
                                        inset="0"
                                        filter="blur(24px) brightness(0.85)"
                                        transform="scale(1.15)"
                                        pointerEvents="none"
                                      >
                                        <NextImage
                                          layout="fill"
                                          objectFit="cover"
                                          priority
                                          sizes="(max-width: 768px) 100vw, 700px"
                                          src={heroImg}
                                          alt=""
                                        />
                                      </Box>
                                      {/* This image defaults to the primary img upon load and doesn't wait for the whole array to get filled out to land on the 0 index */}
                                      <NextImage
                                        layout="fill"
                                        objectFit="contain"
                                        priority
                                        sizes="(max-width: 768px) 100vw, 700px"
                                        src={heroImg}
                                        alt={subject}
                                        onClick={onOpen}
                                      />
                                      {imageArray?.length > 1 ? (
                                        <ImageDrawer
                                          elementId={activeImg}
                                          saveAndShare={SaveAndShare}
                                          drawerClose={onClose}
                                          drawerOpen={isOpen}
                                          images={imageArray}
                                        />
                                      ) : (
                                        <SlideshowModal
                                          images={imageArray}
                                          modalOpen={isOpen}
                                          modalClose={onClose}
                                          imgId={activeImg}
                                        />
                                      )}
                                    </InnerImage3>
                                  </InnerImage2>
                                </InnerImage1>
                              </ImageHolder>
                            </span>
                            <NavigationDotsHolder>
                              <NavigationInnerDiv>
                                <ScrollPreventer>
                                  <div
                                    style={{
                                      alignItems: "flex-end",
                                      display: "flex",
                                      justifyContent: "center",
                                      listStyleType: "none",
                                      margin: "0px",
                                      padding: "0px",
                                      transition:
                                        "transform 0.2s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s, transform 0.2s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s, transform 0.2s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s",
                                      transform: `translateX(${translateValue}px)`,
                                    }}
                                  >
                                    {/* Scale Logic
                                                                if activeimg is >=2 and less
                                                                if index of the dot is index + 2 or index - 2, 0.83333 scale
                                                                if index of the dot is >= index + 3 or <= index - 3, 0.67777 scale

                                                                */}
                                    {/* Inactive and active based on image being viewed */}
                                    {imageArray?.map((item, index) => (
                                      <span
                                        key={item}
                                        className={
                                          index === activeImg
                                            ? "activeDot"
                                            : "inactiveDot"
                                        }
                                        style={{
                                          transform: `scale(${activeImg >= 2 &&
                                            activeImg < imageArray?.length - 3
                                            ? index === activeImg + 2 ||
                                              index === activeImg - 2
                                              ? 0.83333
                                              : index >= activeImg + 3 ||
                                                index <= activeImg - 3
                                                ? 0.677777
                                                : 1
                                            : 1
                                            })`,
                                        }}
                                      />
                                    ))}
                                  </div>
                                </ScrollPreventer>
                              </NavigationInnerDiv>
                            </NavigationDotsHolder>
                          </ImageNavigationHolder>
                        </ImageScroller>

                        {imageArray?.length >= 2 && (
                          <NavButtonHolder>
                            <NavButtonDiv2>
                              {activeImg !== 0 && (
                                <NavButtonLeft
                                  onClick={() => {
                                    if (
                                      activeImg >= 3 &&
                                      activeImg < imageArray?.length - 2
                                    ) {
                                      setTranslateValue(translateValue + 11);
                                    }
                                    setActiveImg(activeImg - 1);
                                  }}
                                >
                                  <NavButton>
                                    <span>
                                      <MdChevronLeft size="24px" />
                                    </span>
                                  </NavButton>
                                </NavButtonLeft>
                              )}

                              {activeImg !== imageArray?.length - 1 && (
                                <NavButtonRight
                                  onClick={() => {
                                    if (
                                      activeImg >= 2 &&
                                      activeImg < imageArray?.length - 3
                                    ) {
                                      setTranslateValue(translateValue - 11);
                                    }
                                    setActiveImg(activeImg + 1);
                                  }}
                                >
                                  <NavButton>
                                    <span>
                                      <MdChevronRight size="24px" />
                                    </span>
                                  </NavButton>
                                </NavButtonRight>
                              )}
                            </NavButtonDiv2>
                          </NavButtonHolder>
                        )}
                      </div>
                    </OuterShell>
                  </ListingPhotoHolder>
                )}
              </Flex>

              {/* Show image box as long as at least a primary image exists */}

              {/* 
              {presentations?.length > 0 &&
                !router.pathname.includes("presentation") && (
                  <>
                    <HeaderLine>Combined offer</HeaderLine>
                    <div className={styles.sectionDivider} />
                    <Flex
                      flexDir={{ base: "column", sm: "row" }}
                      w="100%"
                      alignItems="flex-start"
                      justifyContent="space-between"
                    >
                      <Text>
                        This listing is part of a combined offering.
                      </Text>
                      <Link
                        href={`/presentation/${presentations[0]["id"]}`}
                        passHref
                      >
                        <a>
                          <Button
                            colorScheme="orange"
                            variant="solid"
                            rightIcon={<ArrowForwardIcon />}
                            size="sm"
                            mt={{ base: "8px", sm: "0px" }}
                            borderRadius="1rem"
                          >
                            View combined offer
                          </Button>
                        </a>
                      </Link>
                    </Flex>
                  </>
                )} */}

              <AgentInfoforMobile id="messageBox">
                {/* <HeaderLine>{User?.industryRole === 'Realtor' ? 'Agent Info.' : 'Poster Info.'}</HeaderLine> */}
                {/* <div className={styles.sectionDivider} /> */}
                {ContactBorderBox}
                {roundCTAs}
                {brokeragePhotoComp}
              </AgentInfoforMobile>




              <HeaderLine>Listing Details</HeaderLine>
              <div className={styles.sectionDivider} />

              {/* Only show this field if the user is pro and there is valid info to show */}
              <Attributes>
                {profile?.industryRole == 'Realtor' && brokerCoop && (
                  <p>
                    Co-op commission:{" "}
                    <BoldedSpan>
                      {brokerCoop == "No" 
                        ? "Not co-operating" 
                        : commission?.length > 0 
                          ? commission 
                          : "Please contact"}
                    </BoldedSpan>{" "}
                  </p>
                )}



                {subTypes?.length > 0 && (
                  <p>
                    Subtype: <BoldedSpan>{subTypes?.join(", ")}</BoldedSpan>{" "}
                  </p>
                )}

                {DetailsFields?.map((d) =>
                  fListing[d["value"]] && fListing[d["value"]] != "" ? (
                    <p key={d["value"]}>
                      {d["label"]}:{" "}
                      <BoldedSpan>{fListing[d["value"]]}</BoldedSpan>{" "}
                    </p>
                  ) : null
                )}
                {/* General */}
                {/* {(fListing.brokerCoop && fListing.brokerCoop !== '') &&
                                      <p>Broker Co-Op: <BoldedSpan>{fListing.brokerCoop}</BoldedSpan> </p>
                              } */}

                {lotSize && lotSize !== "" && (
                  <p>
                    Lot Size:{" "}
                    <BoldedSpan>
                      <NumberFormat
                        value={lotSize}
                        displayType={"text"}
                        thousandSeparator={true}
                      />{" "}
                      {lotSizeUnit}
                    </BoldedSpan>{" "}
                  </p>
                )}

                {fListing.tmi && (
                  <p>
                    TMI:{" "}
                    <BoldedSpan>
                      <NumberFormat
                        value={fListing.tmi}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                      />
                    </BoldedSpan>
                  </p>
                )}

                {fListing.tax && fListing.tax !== "" && (
                  <p>
                    Annual Property Tax:{" "}
                    <BoldedSpan>
                      {" "}
                      <NumberFormat
                        value={fListing.tax}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                      />
                    </BoldedSpan>
                  </p>
                )}

                {totalBuildingSize && totalBuildingSize !== "" && (
                  <p>
                    Total Area:{" "}
                    <BoldedSpan>
                      <NumberFormat
                        value={totalBuildingSize}
                        displayType={"text"}
                        thousandSeparator={true}
                      />{" "}
                      sq ft
                    </BoldedSpan>
                  </p>
                )}

                {ceilingHeight && ceilingHeight !== "" && (
                  <p>
                    Clear Height:{" "}
                    <BoldedSpan>{ceilingHeight} ft.</BoldedSpan>
                  </p>
                )}

                {leaseType &&
                  leaseType !== "" &&
                  fListing.type !== "For Sale" && (
                    <p>
                      Lease Type:{" "}
                      <BoldedSpan>{fListing.leaseType}</BoldedSpan>
                    </p>
                  )}
              </Attributes>
              {currentImprovements?.length > 0 && (
                <>
                  <Text mt="1rem" mb="0.25rem">
                    <BoldedSpan>Current improvements:</BoldedSpan>
                  </Text>
                  <Area>{currentImprovements}</Area>
                </>
              )}

              {type == "For Sale" &&
                MoneyFields?.some(
                  (d) => fListing[d["value"]] && fListing[d["value"]] != ""
                ) && (
                  <>
                    <HeaderLine>Financial Details</HeaderLine>
                    <div className={styles.sectionDivider}></div>

                    <Attributes>
                      {MoneyFields?.map((d) =>
                        fListing[d["value"]] && fListing[d["value"]] != "" ? (
                          <p key={d["value"]}>
                            {d["label"]}:{" "}
                            <BoldedSpan>
                              <NumberFormat
                                value={fListing[d["value"]]}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={"$"}
                              />
                            </BoldedSpan>{" "}
                          </p>
                        ) : null
                      )}

                      {PercentFields?.map((d) =>
                        fListing[d["value"]] && fListing[d["value"]] != "" ? (
                          <p key={d["value"]}>
                            {d["label"]}:{" "}
                            <BoldedSpan> {fListing[d["value"]]}%</BoldedSpan>
                          </p>
                        ) : null
                      )}
                    </Attributes>
                  </>
                )}

              {propertyTypes.includes("Sale of Business") &&
                largeBusinessFields?.some(
                  (d) => fListing[d["value"]] && fListing[d["value"]] != ""
                ) && (
                  <>
                    <HeaderLine>About the Business</HeaderLine>
                    <div className={styles.sectionDivider}></div>
                    {largeBusinessFields?.map((d) =>
                      fListing[d["value"]] && fListing[d["value"]] != "" ? (
                        <>
                          <Text key={d["value"]} mt="1rem" mb="0.25rem">
                            <BoldedSpan>{d["label"]}:</BoldedSpan>
                          </Text>
                          <Area>{fListing[d["value"]]}</Area>
                        </>
                      ) : null
                    )}
                  </>
                )}

              {permittedUses?.length > 0 && (
                <>
                  <Text mt="1rem" mb="0.25rem">
                    <BoldedSpan>Permitted uses:</BoldedSpan>
                  </Text>

                  <List spacing={3}>
                    {permittedUses.map((use, index) => (
                      <ListItem key={index}>
                        <ListIcon as={CheckCircleIcon} color="green.500" />
                        {use}
                      </ListItem>
                    ))}
                  </List>
                </>
              )}

              {marketing?.length > 0 && (
                <>
                  <HeaderLine>Description</HeaderLine>
                  <div className={styles.sectionDivider} />

                  <Area>{urlify(removeContactInformation(marketing, { stripUrls: !pro }))}</Area>
                </>
              )}

              {flyerFiles?.length > 0 && (
                <>
                  <HeaderLine>Listing Files</HeaderLine>
                  <div className={styles.sectionDivider} />
                  <Stack spacing={5} align={"flex-start"}>
                    {flyerFiles?.map((file) => (
                      <Button
                        key={file}
                        size="md"
                        variant="link"
                        colorScheme="orange"
                        fontSize="16px"
                        leftIcon={<AiFillFileImage />}
                        cursor="pointer"
                        borderRadius="1.2rem"
                        onClick={() => {
                          user
                            ? visitMutation.mutate({
                              listingId: id,
                              uid: userId,
                              type: "Opened flyer",
                            })
                            : triggerAuth({
                              hook: "Open flyer",
                              header: "Log in or sign up to view file",
                            });
                        }}
                      >
                        {/* Disable click if user signed out */}
                        <a
                          href={file["link"]}
                          target="_blank"
                          style={{ pointerEvents: user ? "auto" : "none" }}
                        >
                          {file?.description}
                        </a>
                      </Button>
                    ))}
                  </Stack>
                </>
              )}

              {fListing?.videoLink && fListing?.videoLink !== "" && (
                <>
                  <HeaderLine>Video</HeaderLine>
                  <div className={styles.sectionDivider} />

                  <YoutubeVideo>
                    <iframe
                      src={`https://www.youtube.com/embed/${fListing?.videoLink}?rel=0&amp;controls=0&amp;autoplay=0&amp;mute=0&amp;start=0`}
                      allowFullScreen
                      title="video"
                      frameBorder="0"
                      style={{
                        position: "absolute",
                        left: "0",
                        top: "0",
                        width: "100%",
                        height: "100%",
                        pointerEvents: "auto",
                      }}
                      allow="autoplay; encrypted-media"
                    />
                  </YoutubeVideo>
                </>
              )}

              {website?.length > 1 && pro && (
                <Box my="1.5rem" color="#125F3F" fontSize="17px">
                  <Box
                    as="span"
                    cursor="pointer"
                    onClick={(e) => {
                      e.preventDefault();
                      if (user) {
                        const url = website.slice(0, 4) === "http"
                          ? website
                          : "https://" + website;
                        window.open(url, "_blank");
                      } else {
                        triggerAuth({
                          hook: "View external link",
                          header: "Sign in or sign up to view external link",
                        });
                      }
                    }}
                    _hover={{
                      textDecoration: "underline",
                    }}
                  >
                    {websiteDescription?.length > 2
                      ? websiteDescription
                      : "Visit marketing link"}{" "}
                    <ExternalLinkIcon mx="2px" />
                  </Box>
                </Box>
              )}

              {Unit.length > 0 && (
                <>
                  <HeaderLine>Available Units and Spaces</HeaderLine>
                  {/* <div className={styles.sectionDivider} /> */}
                  <Accordion allowMultiple>
                    {Unit.map((unit) => (
                      <AccordionItem key={unit.id}>
                        <h2>
                          <AccordionButton>
                            <Box as="span" flex='1' textAlign='left'
                              display={"flex"}
                              justifyContent={"space-between"}
                              fontSize="14px"
                              gap={"16px"}
                            >
                              <Flex>
                                <Flex
                                  mr="12px"
                                  alignItems={"center"}
                                >

                                  <CircleIcon color={unit.isAvailable ? 'green' : 'red.500'} />
                                </Flex>
                                {unit.shortDescription}
                              </Flex>

                              <Box display={{ base: "none", md: "block" }}>
                                {(unit.price === 0 || unit.isNegotiable) ? "Price negotiable" :
                                  <NumberFormat
                                    value={unit.price}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={"$"}
                                    suffix={type == 'For Lease' ?
                                      `/${priceType} ${leaseType ? `(${leaseType})` : ""}` : ""
                                    }
                                  />}
                              </Box>

                              {/* Show this field if any of the units have unit info */}
                              {Unit.some((u) => u.size) && (

                                <Box display={{ base: "none", md: "block" }}>
                                  {unit.size ? `${unit.size} SF` : ""}
                                </Box>
                              )}

                              <Flex
                                alignItems={"center"}
                              >
                                <AccordionIcon />
                              </Flex>
                            </Box>
                          </AccordionButton>
                        </h2>
                        <AccordionPanel>
                          <Box mt="12px">
                            <Box fontSize="14px" display={{ base: "block", md: "none" }}>
                              Rate: {(unit.price === 0 || unit.isNegotiable) ? "Price negotiable" :
                                <NumberFormat
                                  value={unit.price}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"$"}
                                  suffix={
                                    `/${priceType} ${leaseType ? `(${leaseType})` : ""
                                    }`
                                  }
                                />}
                            </Box>

                            <Text fontSize={"14px"} display={{ base: "block", md: "none" }}>
                              Size: {unit.size} SF
                            </Text>
                            <Text fontSize={"14px"}
                              whiteSpace='pre-line'
                              wordBreak='break-word'

                            >{removeContactInformation(unit.longDescription, { stripUrls: !pro })}</Text>
                            {!signedInUserOwnsListing && messageStatus !== 'success' && unit.isAvailable && (
                              <Button
                                mt="16px"
                                size="sm"
                                onClick={() => {
                                  const message = 'Hi, can I please get some more details about ' + unit.shortDescription + '?';
                                  if (profile) {
                                    setMessageText(message);
                                    messageMutation.mutate({
                                      listingId: id,
                                      uid: userId,
                                      message,
                                    })
                                  }

                                  else {
                                    triggerAuth({
                                      hook: "Message about Lease Unit",
                                      header: "Log in or sign up to request details",
                                    });

                                    setMessageText(message);
                                    setMessageToSend(true);
                                  }
                                }}
                                colorScheme="green"
                                variant={'outline'}
                              >Request Details</Button>
                            )}
                          </Box>
                        </AccordionPanel>
                      </AccordionItem>
                    ))}
                  </Accordion>

                  {Unit.some((unit) => !unit.isAvailable) && (
                    <Flex
                      mt="12px"
                      alignItems={"center"}
                      justifyContent={"flex-end"}
                      fontSize="14px"
                    >

                      <CircleIcon mr="3px" color={'green'} /> <Text mr="20px">Available</Text>  <CircleIcon mr="3px" color={'red.500'} />Not Available
                    </Flex>)}
                </>
              )}
              {coordinates && (
                <>
                  <HeaderLine>Location & nearby</HeaderLine>
                  <div className={styles.sectionDivider} />

                  <FancyText>
                    {`This listing is located in ${city ? `${city}, ` : ""}${province ? provinceShorter(province) : ""
                      }`}{" "}
                    {postal?.length > 0 ? `${postal}` : ""}
                  </FancyText>

                  <Box
                    fontWeight="500"
                    display="inline-flex"
                    alignItems="center"
                    mb="20px"
                  >
                    <Box>
                      <Box as={RiMapPin2Fill} size="16px" mr="5px" />
                    </Box>
                    {fListing.unit?.length > 0
                      ? `Unit #${fListing.unit} `
                      : ""}
                    {fListing.address}
                  </Box>

                  {isLoaded && (
                    <>
                      <MapHolder>
                        <div
                          style={{
                            height: "300px",
                            width: "100%",
                            position: "relative",
                          }}
                        >
                          <GoogleMap
                            mapContainerStyle={mapContainerStyle}
                            zoom={showAddress ? 15 : 12}
                            options={options}
                            center={fListing?.coordinates}
                            onLoad={onMapLoad}
                          >
                            <Marker
                              clickable={false}
                              position={fListing?.coordinates}
                              icon={{
                                url: "/images/marker.svg",
                              }}
                            />
                            {!fListing.showAddress && (
                              <>
                                <Circle
                                  center={fListing?.coordinates}
                                  radius={3000}
                                  options={{
                                    clickable: false,
                                    fillColor: "#000000",
                                    fillOpacity: 0.2,
                                    strokeColor: "#000000",
                                    strokeOpacity: 0.2,
                                    strokeWeight: 1,
                                    zIndex: 105,
                                  }}
                                />

                                <Box
                                  position="absolute"
                                  bottom="0px"
                                  marginBottom="20px"
                                  whiteSpace="nowrap"
                                  left="50%"
                                  transform="translateX(-50%)"
                                >
                                  <Box
                                    whiteSpace="nowrap"
                                    borderRadius="4px"
                                    display="inline-flex"
                                    flexDirection="column"
                                    overflow="hidden"
                                    padding="10px 14px 10px"
                                    backgroundColor="white"
                                  >
                                    <Text
                                      fontWeight="400"
                                      lineHeight="18px"
                                      fontSize="12px"
                                      color="#222"
                                    >
                                      Location is approximate.
                                    </Text>
                                  </Box>
                                </Box>
                              </>
                            )}
                          </GoogleMap>
                        </div>
                      </MapHolder>

                      {/* Street view  */}

                      {streetViewEnabled && (
                        <>
                          <Button
                            m="15px auto 15px"
                            display="flex"
                            alignItems={"center"}
                            variant="outline"
                            colorScheme={"green"}
                            onClick={toggleStreetView}
                            rightIcon={<FaStreetView />}
                          >
                            {showingStreetView ? "Hide" : "Show"} street view
                          </Button>
                          {showingStreetView && (
                            <MapHolder>
                              <div
                                style={{
                                  height: "300px",
                                  width: "100%",
                                  position: "relative",
                                  marginTop: "16px",
                                }}
                              >
                                <GoogleMap
                                  id="circle-example"
                                  options={options}
                                  mapContainerStyle={mapContainerStyle}
                                  zoom={15}
                                  center={coordinates}
                                >
                                  <StreetViewPanorama
                                    options={{
                                      position: coordinates,
                                      visible: true,
                                    }}
                                  />
                                </GoogleMap>
                              </div>
                            </MapHolder>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}

              {fListing.coListers.length > 0 && (
                <>

                  <HeaderLine>Listing contacts</HeaderLine>
                  <div className={styles.sectionDivider} />
                  <ContactsGrid>
                    {[{ photoURL, brokeragePhoto, slug, fullName, industryRole, pro }, ...fListing.coListers].map((coLister) => (
                      <AgentOuterShell>
                        <Link href={`/profile/${coLister.slug}`}>
                          <CardAnchor target="_blank">
                            <Flex
                              alignItems={"center"}
                              justifyContent={"space-between"}
                              width="100%"
                            >
                              <Flex

                              >

                                <Avatar
                                  size="md"
                                  src={coLister.photoURL}
                                />

                                <Flex
                                  marginLeft="16px"
                                  alignItems="center"
                                >
                                  <Box>

                                    <SmallFancyBold>{coLister.fullName}</SmallFancyBold>
                                    <Flex mt="4px">
                                      {coLister.pro && (
                                        <Badge
                                          mr="6px"
                                          variant="solid"
                                          colorScheme="green"
                                        >
                                          Pro
                                        </Badge>
                                      )}
                                      <Badge
                                        variant="outline"
                                        colorScheme={"gray"}
                                        display="inline-block"
                                      >
                                        {coLister.industryRole}
                                      </Badge>
                                    </Flex>
                                  </Box>
                                </Flex>
                              </Flex>
                              {coLister.brokeragePhoto &&
                                <Box
                                  width="80px"
                                  height={"auto"}
                                  position={"relative"}
                                  marginTop={{ base: "20px", md: "0px" }}
                                  marginBottom={{ base: "20px", md: "0px" }}
                                >
                                  <Image src={coLister.brokeragePhoto}
                                    objectFit="contain"
                                    max-width="100%" height="100%" />
                                </Box>
                              }

                            </Flex>



                          </CardAnchor>
                        </Link>
                      </AgentOuterShell>

                    ))}
                  </ContactsGrid>
                </>
              )}


              {!userId && listingIsAvailable && (
                <AskAQuestionContainer>
                  <VStack alignItems={"flex-start"}>
                    <Text
                      fontWeight={"600"}
                      fontSize="24px"
                      lineHeight={"18px"}
                    >
                      Ask a question
                    </Text>
                    <Text fontSize="15px">
                      Curious about any of the details? Ask the listing owner a question and get a quick answer.
                    </Text>
                  </VStack>
                  <Button
                    bgColor="#0B76D9"
                    color="#fff"
                    py="20px"
                    px="35px"
                    _hover={{
                      opacity: "0.8",
                    }}
                    onClick={() => {
                      clientAnalytics.track("Ask a question clicked");
                      
                      setQuestionsLeadFormOpen(true);
                    }}
                  >
                    Ask a question
                  </Button>
                </AskAQuestionContainer>
              )}

              {listingIsAvailable && (!thisListingConversationId || userIsNotSignedIn) &&
                <>

                  {userId &&
                    <>
                      <HeaderLine>
                        Ask a question   <Box display={"inline-block"}><Badge colorScheme='green' variant={'subtle'}>NEW!</Badge></Box>
                      </HeaderLine>
                      <div className={styles.sectionDivider} />
                    </>
                  }
                  <OptionsHeader>
                    Ask the {industryRole == 'Realtor' ? "agent" : "seller"} a question about this listing in one click
                  </OptionsHeader>
                  <OptionButtonList>
                    {commonQuestions.map((i, index) => (
                      <OptionButton key={index}
                        onClick={() => { commonQuestionRequest(i) }}>
                        {i}
                      </OptionButton>
                    ))}
                    <OptionButton
                      onClick={onMessageBoxOpen}
                    >
                      Ask your own question
                    </OptionButton>
                  </OptionButtonList>

                  <Box h="60px"></Box>
                </>
              }



            </ListingContents>

            <AgentInfoforDesktop id="messageBox" size={"desktop"}>
              <Box position="sticky" top="80px">
                {ContactBorderBox}
                {pro && !!phone && (
                  <Box w="fit-content" margin="15px auto">
                    <PhoneJSX />
                  </Box>
                )}

                {/* Round CTAs */}
                {roundCTAs}

                {brokeragePhotoComp}

                {/* {!signedInUserOwnsListing &&
                  <ContactBorder size={size}>
                    <FormControl display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
                      
                        <FormLabel htmlFor="similarListingAlert" mb={"0px"} display="inline-flex" alignItems={"center"}> 
                          <BellIcon boxSize={5} mr="5px"/>  Alert me about listings like these
                        </FormLabel>

                      <Switch
                        tabIndex={-1}
                        isChecked={similarListingAlertExists} 
                        colorScheme="green" 
                        id="similarListingAlert" 
                        onChange={listingAlertRequest} />
                    </FormControl>
                  </ContactBorder>
                } */}
              </Box>
            </AgentInfoforDesktop>
          </ListingandContact>
          {/* Virtual Tour */}


          {priority > 1 && industryRole == 'Realtor' &&
            <AboutTheAgentHolder>
              <AboutAgentHeader>
                <AboutAgentHeaderLine>
                  About the agent
                </AboutAgentHeaderLine>




              </AboutAgentHeader>

              <AboutAgentOverallFlex
              >
                <AboutAgentLeftBio>

                  <Flex flexDir={"column"} justifyContent="center" alignItems={'center'}>

                    <Box
                      w={'150px'}
                      h={'150px'}
                      margin="0 auto"
                      borderRadius="50%"
                    >
                      <Link href={`/profile/${slug}`}>

                        <Image src={photoURL} objectFit='contain' maxWidth={"100%"} height="100%" alt={fullName}
                          borderRadius="50%"
                        />

                      </Link>
                    </Box>
                    <AboutAgentBrokerageHolder
                    >
                      <Image src={brokeragePhoto}
                        objectFit="contain"
                        max-width="100%" height="100%" />
                    </AboutAgentBrokerageHolder>

                    <Box w="fit-content" margin="15px auto">
                      <PhoneJSX />
                    </Box>
                  </Flex>


                </AboutAgentLeftBio>

                <AboutAgentRightBio>
                  <AboutAgentTitle>
                    <span style={{ marginRight: "6px" }}>{`${fullName}, ${title}`} </span> <Flex alignItems={"center"}><Badge
                      mr="6px"
                      variant="solid"
                      lineHeight={1.7}
                      colorScheme="green"
                    >
                      Pro
                    </Badge></Flex><MdVerified color="#125f3f" />
                  </AboutAgentTitle>
                  <AboutAgentBioText>
                    {about}
                  </AboutAgentBioText>
                </AboutAgentRightBio>
              </AboutAgentOverallFlex>


            </AboutTheAgentHolder>
          }

          {!user &&
            !router.pathname.includes("presentation") &&
            propertyTypes.filter((value) =>
              funnelTypes.includes(value?.toLowerCase())
            ).length > 0 && (
              <>
                <Divider
                  mt="67px"
                  mb="25px"
                  w="100%"
                  orientation="horizontal"
                  border="none"
                  h="2px"
                  background="#E4E4E4"
                />

                <MultifamilyBanner>
                  <Text
                    color="white"
                    fontSize={"24px"}
                    fontWeight="500"
                    fontFamily="'Jarkarta', sans-serif"
                  >
                    Looking for the right{" "}
                    {propertyTypes
                      ?.find((value) =>
                        funnelTypes.includes(value?.toLowerCase())
                      )
                      ?.toLowerCase()}{" "}
                    listing for you?
                  </Text>
                  <Button
                    fontWeight="500"
                    onClick={() =>
                      router.push({
                        pathname: `/path/${slugify(propTypeForFunnel)}`,
                        query: {
                          CTA: "Listing page banner",
                          buttonText: "Take the Quiz",
                        },
                      })
                    }
                    mt="24px"
                    variant="solid"
                    color={"white"}
                    _hover={{
                      bg: "#74C493",
                    }}
                    _focus={{
                      boxShadow: "none",
                    }}
                    bg="#39AB65"
                    rightIcon={<ArrowForwardIcon />}
                    fontFamily="'Jarkarta', sans-serif"
                  >
                    Take the quiz
                  </Button>
                </MultifamilyBanner>
              </>
            )}


          {/* Similar Listings */}
          {sortedBusinessListingsInCity?.length > 0 &&
            SimilarBusinessListings}

          {RelevantListings}

          {sortedAllListings?.length > 0 && AllSimilarListings}

          {/* Other from poster */}
          {otherFromPoster?.length > 0 && (
            <>
              <Flex
                mb="3px"
                mt="30px"
                alignItems="flex-end"
                justifyContent="space-between"
              >
                <Link
                  prefetch={false}
                  href={{
                    pathname: "/listings",
                    query: { user: uid },
                  }}>
                  <LinkHeaderLine>
                    More listings from {fullName}
                  </LinkHeaderLine>
                </Link>

                <Link
                  href={{
                    pathname: "/listings",
                    query: { user: uid },
                  }}>

                  <Button
                    colorScheme="green"
                    variant="solid"
                    size="sm"
                    mb="3px"
                    borderRadius="20px"
                  >
                    View all
                  </Button>

                </Link>
              </Flex>

              {/* <div className={styles.sectionDivider} /> */}
              <Box
                marginTop="12px"
                overflow="hidden"
                position="relative"
                transition="all 0.5s ease"
              >
                <Flex
                  ref={scroller}
                  transform={`translateX(${translatePixels + "px"})`}
                  overflowX="auto"
                >
                  {otherFromPoster?.map((listing) => (
                    <Link
                      key={listing.id}
                      href={`?listingId=${listing.id}`}
                      as={`/listings/${encodeURIComponent(
                        listing.id
                      )}/${slugify(listing.subject.toProperCase())}`}>

                      <RelevantListing {...listing} />

                    </Link>
                  ))}

                  {/* Only show right button if the number of listings exceeds the width */}

                  <PseudoListingBox>
                    <RelevantImg>
                      <NextImage
                        layout="fill"
                        objectFit="cover"
                        src={`/images/listing/listingTypes/${SubTypePhotos(
                          propertyTypes[0]
                        )}.jpg`}
                      />
                    </RelevantImg>
                    <Box p="12px 14px 14px">
                      <Text
                        color="#1a202c"
                        as="h3"
                        fontSize="13.5px"
                        fontWeight="600"
                        lineHeight="1.4"
                        marginBottom="12px"
                      >
                        See more listings from <Bolder>{fullName}</Bolder>
                      </Text>

                      <Link
                        href={{
                          pathname: "/listings",
                          query: { user: uid },
                        }}>
                        <Button
                          width="100%"
                          size="sm"
                          borderColor={"brand.900"}
                          color={"brand.900"}
                          _hover={{ borderColor: "brand.800" }}
                          variant="outline"
                        >
                          See More
                        </Button>
                      </Link>
                    </Box>
                  </PseudoListingBox>
                </Flex>
              </Box>
            </>
          )}
        </ListingPadder>

        {/* <Footer /> */}
      </ListingPanel>

      <Box h="50px" />

      {/* <NewFooter faq={false} isProfessional={false} /> */}

      <StickyContact>
        <Flex w="100%" justifyContent={"center"}>
          {listingIsAvailable &&
            (messageStatus === "success" ? (
              <Box>
                <Alert mt="12px" status="success" variant="subtle">
                  <AlertIcon />
                  <Box>
                    <AlertTitle fontWeight="600">
                      {" "}
                      You've messaged {firstName.toProperCase()}.{" "}
                    </AlertTitle>
                    <AlertDescription>
                      <Link href={`/inbox?conv=${thisListingConversationId}`}>

                        <Button
                          rightIcon={<ArrowForwardIcon />}
                          fontWeight={"600"}
                          verticalAlign={"inherit"}
                          paddingY="0px"
                          marginY="0px"
                          variant="link"
                          colorScheme="green"
                        >
                          Go to the chat
                        </Button>

                      </Link>
                    </AlertDescription>
                  </Box>
                </Alert>
              </Box>
            ) : (
              <Button
                size="lg"
                flex="1"
                maxW="400px"
                // leftIcon={<ChatIcon />}
                colorScheme="green"
                onClick={onMessageBoxOpen}
              >
                Send a Message
              </Button>
            ))}

          {listingIsExpired && !signedInUserOwnsListing &&
            <Button
              bgColor="#0B76D9"
              color="#fff"
              width={{ base: "100%", sm: null }}
              py="20px"
              px="35px"
              isDisabled={similarListingAlertStatus == "success"}
              isLoading={similarListingAlertStatus == "loading"}
              leftIcon={
                similarListingAlertStatus ==
                  "success" ? (
                  <CheckIcon />
                ) : (
                  <EmailIcon />
                )
              }
              _hover={{
                opacity: "0.8",
              }}
              onClick={() => {
                setSimilarListingAlertPending(true);
                triggerAuth({
                  hook: "Notify me for listings like these",
                  header:
                    "Create a free account to confirm your alert",
                });
              }}
              size="lg"
              flex="1"
              maxW="400px"
            // colorScheme={"green"}
            // leftIcon={<ChatIcon />}
            >
              {similarListingAlertStatus == "success"
                ? "Alert created"
                : "Alert me for the next one"}
            </Button>
          }
        </Flex>
      </StickyContact>
      <AuthModal
        returnToListing
        signUpMethod={signUpMethod}
        authModalEmail={authModalEmail}
        authModalEmailType={authModalEmailType}
        authModalPhoneType={authModalPhoneType}
        header={authHeader}
        onClose={onAuthBoxClose}
        isOpen={isAuthBoxOpen}


      />

      <AlertDialog
        isOpen={isDeleteBlockOpen}
        leastDestructiveRef={deleteBlockCancelRef}
        onClose={onDeleteBlockClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete &amp; Block User
            </AlertDialogHeader>
            <AlertDialogBody>
              This will permanently delete <strong>all listings</strong> by this user (including uploaded images) and <strong>disable their account</strong>. This cannot be undone.
            </AlertDialogBody>
            <AlertDialogFooter gap="8px">
              <Button ref={deleteBlockCancelRef} onClick={onDeleteBlockClose}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDeleteAndBlock} ml={3}>
                Yes, Delete &amp; Block
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      <Modal
        isOpen={isListingStatusModalOpen}
        // initialFocusRef={initialRef}
        isCentered={true}
        onClose={closeListingStatusModal}
        closeOnOverlayClick={false}
        preserveScrollBarGap={true}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Change listing {updateModalMode}</ModalHeader>
          <ModalCloseButton />
          <ModalBody padding="0rem 1.5rem 2.5rem">
            {updateModalMode == 'status' &&
              <Select
                focusBorderColor="green.500"
                value={listingStatusFormValue.current}
                onChange={(e) => {
                  setListingStatusFormValue({
                    ...listingStatusFormValue,
                    current: e.target.value
                  });
                }}
              >
                {ListingStatusOptions.map((opt) => (
                  <option key={opt["value"]} value={opt["value"]}>
                    {opt["label"]}
                  </option>
                ))}
              </Select>
            }
            {
              listingStatusFormValue.initial === listingStatusFormValue.current &&
              <FormErrorMessage>Please choose a different listing status</FormErrorMessage>
            }

            {updateModalMode == 'priority' &&
              <Select
                defaultValue={priority}
                focusBorderColor="green.500"
                value={priorityToSet.current}
                onChange={(e) => {
                  setPriorityToSet({
                    ...priorityToSet,
                    current: parseInt(e.target.value)
                  });
                }}
              >
                <option value={1}>
                  1
                </option>

                <option value={2}>
                  2
                </option>
              </Select>
            }

            {
              priorityToSet.initial === priorityToSet.current &&
              <FormErrorMessage>Please choose a different listing priority</FormErrorMessage>
            }

            <Button
              mt="12px"
              isLoading={updateListing.isLoading}
              loadingText="Updating"
              colorScheme="green"
              variant="solid"
              onClick={() => {
                if (updateModalMode == 'status') {

                  const listingStatusIsUnchanged = listingStatusFormValue.initial === listingStatusFormValue.current
                  if (listingStatusIsUnchanged) {
                    return
                  }
                  updateListing.mutate({
                    status: listingStatusFormValue.current
                  });
                }

                if (updateModalMode == 'priority') {
                  updateListing.mutate({
                    priority: priorityToSet.current
                  });
                }
              }}
            >
              Update listing
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
      <Modal
        closeOnEsc={false}
        closeOnOverlayClick={false}
        isCentered={true}
        isOpen={isModalOpen}
        onClose={onShareBoxClose}
      >
        <ModalOverlay />
        <ModalContent
          zIndex={2147483647}
          maxWidth="568px"
          width="100%"
          borderRadius="12px"
          maxHeight="85vh"
        >
          <>
            <ModalCloseButton />
            <ModalBody overflowY="auto" paddingY="2rem">
              <Subject>
                {modalMode == "share" && "Share this listing with co-workers"}

                {modalMode == "code" && "Verify your phone"}

                {modalMode == "lead" &&
                  `How should ${firstName} get back to you?`}
              </Subject>

              <Box h="12px" />
              {modalMode == "share" && (
                <>
                  <Flex
                    w="100%"
                    justifyContent="flex-start"
                    my="8px"
                    alignItems="center"
                  >
                    {imageArray && (
                      <Box w="120px" mr="8px" h="60px">
                        <Image
                          w="100%"
                          maxW="100%"
                          maxH="100%"
                          src={imageArray[0]}
                          borderRadius="5px"
                        />
                      </Box>
                    )}

                    <SmallFancy>{subject}</SmallFancy>
                  </Flex>
                  <Grid
                    gridRowGap="8px"
                    gridTemplateColumns="minmax(0,1fr)"
                    my="16px"
                  >
                    <SmallFancyBold>Messaging</SmallFancyBold>
                    <ShareHolder>
                      <WhatsappShareButton
                        url={
                          listingUrl +
                          "?utm_source=whatsapp&utm_medium=text&utm_campaign=social_sharing"
                        }
                        onClick={() => shareListing("Whatsapp")}
                        title={`Check out '${subject}' on Zonado`}
                      >
                        <Flex alignItems="center">
                          <Box mr="10px">
                            <WhatsappIcon size={40} round />
                          </Box>
                          <SmallFancyBold>WhatsApp</SmallFancyBold>
                        </Flex>
                      </WhatsappShareButton>

                      <FacebookMessengerShareButton
                        url={
                          listingUrl +
                          "?utm_source=facebookMessenger&utm_medium=text&utm_campaign=social_sharing"
                        }
                        appId={"795889520953136"}
                        onClick={() => shareListing("Facebook messegner")}
                      >
                        <Flex alignItems="center">
                          <Box mr="10px">
                            <FacebookMessengerIcon size={40} round />
                          </Box>
                          <SmallFancyBold>Messenger</SmallFancyBold>
                        </Flex>
                      </FacebookMessengerShareButton>

                      <TelegramShareButton
                        url={
                          listingUrl +
                          "?utm_source=telegram&utm_medium=text&utm_campaign=social_sharing"
                        }
                        title={subject}
                        onClick={() => shareListing("Telegram")}
                      >
                        <Flex alignItems="center">
                          <Box mr="10px">
                            <TelegramIcon size={40} round />
                          </Box>
                          <SmallFancyBold>Telegram</SmallFancyBold>
                        </Flex>
                      </TelegramShareButton>
                    </ShareHolder>

                    <SmallFancyBold>Social Media</SmallFancyBold>
                    <ShareHolder>
                      <FacebookShareButton
                        url={
                          listingUrl +
                          "?utm_source=facebook&utm_medium=social&utm_campaign=social_sharing"
                        }
                        quote={"Check out this listing on Zonado"}
                        onClick={() => shareListing("Facebook")}
                      >
                        <Flex alignItems="center">
                          <Box mr="10px">
                            <FacebookIcon size={40} round />
                          </Box>
                          <Text>Facebook</Text>
                        </Flex>
                      </FacebookShareButton>

                      <LinkedinShareButton
                        url={
                          listingUrl +
                          "?utm_source=linkedin&utm_medium=social&utm_campaign=social_sharing"
                        }
                        title={"Check out this listing on Zonado"}
                        source="Zonado"
                        onClick={() => shareListing("LinkedIn")}
                      >
                        <Flex alignItems="center">
                          <Box mr="10px">
                            <LinkedinIcon size={40} round />
                          </Box>
                          <Text>LinkedIn</Text>
                        </Flex>
                      </LinkedinShareButton>
                    </ShareHolder>

                    <SmallFancyBold>Copy link</SmallFancyBold>
                    <Box className={"flex flex-row"}>
                      <LatestHaveInput
                        disabled
                        value={
                          listingUrl +
                          "?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing"
                        }
                        className={"rounded p-2 mr-1 grow"}
                      />
                      <Button
                        variant="outline"
                        colorScheme="black"
                        fontWeight="400"
                        borderRadius="12px"
                        onClick={copyContent}
                      >
                        Copy
                      </Button>
                    </Box>
                  </Grid>
                </>
              )}

              <div id="recaptcha-container"></div>
            </ModalBody>
          </>
        </ModalContent>
      </Modal>

      <Modal
        closeOnEsc={true}
        closeOnOverlayClick={true}
        isCentered={true}
        isOpen={messageBoxOpen

          // && size.width < 900
        } // hide modal when screen size is above 900px
        onClose={onMessageBoxClose}
      >
        <ModalOverlay />
        <ModalContent p="0px 00px 00px">
          {/* <> */}
          {/* <Box mt="10px"> */}
          {/* <AgentInfoforDesktop id="messageBox" size={"mobile"}> */}
          <ModalCloseButton />

          {ContactBorderBox}
          {/* </AgentInfoforDesktop> */}
          {pro && !!phone && (
            <Box w="fit-content" margin="15px auto 15px">
              <PhoneJSX />
            </Box>
          )}
          {/* </Box> */}
          {/* </> */}
        </ModalContent>
      </Modal>
      <QuestionsLeadForm
        quizType={quizType}
        isOpen={questionsLeadFormOpen}
        // isOpen={true}
        onClose={() => setQuestionsLeadFormOpen(false)}
        messageText={messageText}
        onMessageSent={(id) => {
          setThisListingConversationId(id);
          setQuestionsLeadFormOpen(false);
          setMessageStatus("success");

          if (quizType == 'callback') {
            setCallBackRequested(true);
            try {
              // @ts-ignore
              window?.analytics?.track("Call back requested")
            } catch (error) {
              console.error(error)
            }
          }
        }}

        listingData={{
          id: Number(id),
        }}
      />
    </OverallinModal>
    {/* Commented out to disable exit intent modal */}
    {/* {
    (!!propTypeForFunnel && !profile) &&
      <QuizFunnelModal
        type={
          slugify(propTypeForFunnel)
        }
        isOpen={showQuizFunnel}
        onClose={quizFunnelCancelled}
      />
  } */}
  </>);
};

export default Listing
